
"undefined" == typeof Shopify && (window.Shopify = {}),
"undefined" == typeof theme && (window.theme = {}),
void 0 === Shopify.getCart && (Shopify.getCart = function(b, a) {
    if (!a)
        return jQuery.getJSON("/cart.js", function(a, c, d) {
            "function" == typeof b ? b(a, c, d) : Shopify.onCartUpdate(a)
        });
    "function" == typeof b ? b(a) : "function" == typeof Shopify.onCartUpdate && Shopify.onCartUpdate(a)
}
),
"undefined" != typeof jQuery && function($) {
    var h, i, $ = jQuery = $, b = {
        sections: []
    };
    theme.Shopify = {
        formatMoney: function(a, f) {
            function g(a, b) {
                return void 0 === a ? b : a
            }
            function c(a, b, c, d) {
                if (b = g(b, 2),
                c = g(c, ","),
                d = g(d, "."),
                isNaN(a) || null == a)
                    return 0;
                var e = (a = (a / 100).toFixed(b)).split(".");
                return e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + c) + (e[1] ? d + e[1] : "")
            }
            "string" == typeof a && (a = a.replace(".", ""));
            var b = ""
              , d = /\{\{\s*(\w+)\s*\}\}/
              , e = f || this.money_format;
            switch (e.match(d)[1]) {
            case "amount":
                b = c(a, 2);
                break;
            case "amount_no_decimals":
                b = c(a, 0);
                break;
            case "amount_with_comma_separator":
                b = c(a, 2, ".", ",");
                break;
            case "amount_with_space_separator":
                b = c(a, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                b = c(a, 2, " ", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                b = c(a, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                b = c(a, 0, " ", "");
                break;
            case "amount_with_apostrophe_separator":
                b = c(a, 2, "'", ".");
                break;
            case "amount_with_decimal_separator":
                b = c(a, 2, ".", ".")
            }
            return e.replace(d, b)
        },
        formatImage: function(a, b) {
            return a ? a.replace(/^(.*)\.([^\.]*)$/g, "$1_" + b + ".$2") : ""
        },
        Image: {
            imageSize: function(b) {
                var a = b.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null !== a ? a[1] : null
            },
            getSizedImageUrl: function(a, b) {
                if (null == b)
                    return a;
                if ("master" == b)
                    return this.removeProtocol(a);
                var c = a.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != c) {
                    var d = a.split(c[0])
                      , e = c[0];
                    return this.removeProtocol(d[0] + "_" + b + e)
                }
                return null
            },
            removeProtocol: function(a) {
                return a.replace(/http(s)?:/, "")
            }
        }
    };
    class j {
        constructor(a) {
            var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(a)
              , c = this;
            this.instances = [],
            $(document).on("cc:component:load", function(f, d, e) {
                d === a && $(e).find("".concat(b, ":not(.cc-initialized)")).each(function() {
                    c.init(this)
                })
            }),
            $(document).on("cc:component:unload", function(f, d, e) {
                d === a && $(e).find(b).each(function() {
                    c.destroy(this)
                })
            }),
            $(b).each(function() {
                c.init(this)
            })
        }
        init(a) {
            $(a).addClass("cc-initialized")
        }
        destroy(a) {
            $(a).removeClass("cc-initialized")
        }
        registerInstance(a, b) {
            this.instances.push({
                container: a,
                instance: b
            })
        }
        destroyInstance(a) {
            this.instances = this.instances.filter(b=>{
                if (b.container === a)
                    return "function" == typeof b.instance.destroy && b.instance.destroy(),
                    b.container !== a
            }
            )
        }
    }
    (h = document.createEvent("Event")).initEvent("throttled-scroll", !0, !0),
    window.addEventListener("scroll", function(a, b) {
        var c = -1
          , d = !1;
        return function() {
            clearTimeout(c),
            c = setTimeout(a, b),
            d || (a.call(),
            d = !0,
            setTimeout(function() {
                d = !1
            }, b))
        }
    }(function() {
        window.dispatchEvent(h)
    }, 200)),
    theme.Sections = new function() {
        var _ = this;
        _._instances = [],
        _._deferredSectionTargets = [],
        _._sections = [],
        _._deferredLoadViewportExcess = 300,
        _._deferredWatcherRunning = !1,
        _.init = function() {
            $(document).on("shopify:section:load", function(b) {
                var a = _._themeSectionTargetFromShopifySectionTarget(b.target);
                a && _.sectionLoad(a)
            }).on("shopify:section:unload", function(b) {
                var a = _._themeSectionTargetFromShopifySectionTarget(b.target);
                a && _.sectionUnload(a)
            }).on("shopify:section:reorder", function(b) {
                var a = _._themeSectionTargetFromShopifySectionTarget(b.target);
                a && _.sectionReorder(a)
            }),
            $(window).on("throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader", _._processDeferredSections),
            _._deferredWatcherRunning = !0
        }
        ,
        _.register = function(b, c, a) {
            _._sections.push({
                type: b,
                section: c,
                afterSectionLoadCallback: a ? a.afterLoad : null,
                afterSectionUnloadCallback: a ? a.afterUnload : null
            }),
            $('[data-section-type="' + b + '"]').each(function() {
                Shopify.designMode || a && !1 === a.deferredLoad || !_._deferredWatcherRunning ? _.sectionLoad(this) : _.sectionDeferredLoad(this, a)
            })
        }
        ,
        _.sectionDeferredLoad = function(b, a) {
            _._deferredSectionTargets.push({
                target: b,
                deferredLoadViewportExcess: a && a.deferredLoadViewportExcess ? a.deferredLoadViewportExcess : _._deferredLoadViewportExcess
            }),
            _._processDeferredSections(!0)
        }
        ,
        _._processDeferredSections = function(h) {
            if (_._deferredSectionTargets.length)
                for (var b = $(window).scrollTop(), d = b + $(window).height(), j = !0 === h ? _._deferredSectionTargets.length - 1 : 0, a = j; a < _._deferredSectionTargets.length; a++) {
                    var e = _._deferredSectionTargets[a].target
                      , i = _._deferredSectionTargets[a].deferredLoadViewportExcess
                      , c = $(e).offset().top - i
                      , f = c > b && c < d;
                    if (!f) {
                        var g = c + $(e).outerHeight() + 2 * i;
                        f = g > b && g < d
                    }
                    (f || c < b && g > d) && (_.sectionLoad(e),
                    _._deferredSectionTargets.splice(a, 1),
                    a--)
                }
            !0 !== h && 0 === _._deferredSectionTargets.length && (_._deferredWatcherRunning = !1,
            $(window).off(".themeSectionDeferredLoader"))
        }
        ,
        _.sectionLoad = function(a) {
            var a = a
              , d = _._sectionForTarget(a)
              , b = !1;
            if (!1 !== (b = d.section ? d.section : d)) {
                var c = {
                    target: a,
                    section: b,
                    $shopifySectionContainer: $(a).closest(".shopify-section"),
                    thisContext: {
                        functions: b.functions,
                        registeredEventListeners: []
                    }
                };
                c.thisContext.registerEventListener = _._registerEventListener.bind(c.thisContext),
                _._instances.push(c),
                $(a).data("components") && $(a).data("components").split(",").forEach(b=>{
                    $(document).trigger("cc:component:load", [b, a])
                }
                ),
                _._callSectionWith(b, "onSectionLoad", a, c.thisContext),
                _._callSectionWith(b, "afterSectionLoadCallback", a, c.thisContext),
                b.onSectionSelect && c.$shopifySectionContainer.on("shopify:section:select", function(a) {
                    _._callSectionWith(b, "onSectionSelect", a.target, c.thisContext)
                }),
                b.onSectionDeselect && c.$shopifySectionContainer.on("shopify:section:deselect", function(a) {
                    _._callSectionWith(b, "onSectionDeselect", a.target, c.thisContext)
                }),
                b.onBlockSelect && $(a).on("shopify:block:select", function(a) {
                    _._callSectionWith(b, "onBlockSelect", a.target, c.thisContext)
                }),
                b.onBlockDeselect && $(a).on("shopify:block:deselect", function(a) {
                    _._callSectionWith(b, "onBlockDeselect", a.target, c.thisContext)
                })
            }
        }
        ,
        _.sectionUnload = function(b) {
            for (var e = _._sectionForTarget(b), d = -1, a = 0; a < _._instances.length; a++)
                _._instances[a].target == b && (d = a);
            if (d > -1) {
                var c = _._instances[d];
                $(b).off("shopify:block:select shopify:block:deselect"),
                c.$shopifySectionContainer.off("shopify:section:select shopify:section:deselect"),
                _._callSectionWith(c.section, "onSectionUnload", b, c.thisContext),
                _._unloadRegisteredEventListeners(c.thisContext.registeredEventListeners),
                _._callSectionWith(e, "afterSectionUnloadCallback", b, c.thisContext),
                _._instances.splice(d),
                $(b).data("components") && $(b).data("components").split(",").forEach(a=>{
                    $(document).trigger("cc:component:unload", [a, b])
                }
                )
            } else
                for (var a = 0; a < _._deferredSectionTargets.length; a++)
                    if (_._deferredSectionTargets[a].target == b) {
                        _._deferredSectionTargets[a].splice(a, 1);
                        break
                    }
        }
        ,
        _.sectionReorder = function(c) {
            for (var b = -1, a = 0; a < _._instances.length; a++)
                _._instances[a].target == c && (b = a);
            if (b > -1) {
                var d = _._instances[b];
                _._callSectionWith(d.section, "onSectionReorder", c, d.thisContext)
            }
        }
        ,
        _._registerEventListener = function(a, b, c) {
            a.addEventListener(b, c),
            this.registeredEventListeners.push({
                element: a,
                eventType: b,
                callback: c
            })
        }
        ,
        _._unloadRegisteredEventListeners = function(a) {
            a.forEach(a=>{
                a.element.removeEventListener(a.eventType, a.callback)
            }
            )
        }
        ,
        _._callSectionWith = function(c, a, b, d) {
            if ("function" == typeof c[a])
                try {
                    d ? c[a].bind(d)(b) : c[a](b)
                } catch (e) {
                    var f = b.dataset.sectionType;
                    console.warn("Theme warning: '".concat(a, "' failed for section '").concat(f, "'")),
                    console.debug(b, e)
                }
        }
        ,
        _._themeSectionTargetFromShopifySectionTarget = function(b) {
            var a = $("[data-section-type]:first", b);
            return a.length > 0 && a[0]
        }
        ,
        _._sectionForTarget = function(b) {
            for (var c = $(b).attr("data-section-type"), a = 0; a < _._sections.length; a++)
                if (_._sections[a].type == c)
                    return _._sections[a];
            return !1
        }
        ,
        _._sectionAlreadyRegistered = function(b) {
            for (var a = 0; a < _._sections.length; a++)
                if (_._sections[a].type == b)
                    return !0;
            return !1
        }
    }
    ,
    theme.Disclosure = function() {
        var b = {
            disclosureList: "[data-disclosure-list]",
            disclosureToggle: "[data-disclosure-toggle]",
            disclosureInput: "[data-disclosure-input]",
            disclosureOptions: "[data-disclosure-option]"
        }
          , c = {
            listVisible: "disclosure-list--visible"
        };
        function a(a) {
            this.$container = a,
            this.cache = {},
            this._cacheSelectors(),
            this._connectOptions(),
            this._connectToggle(),
            this._onFocusOut()
        }
        return a.prototype = $.extend({}, a.prototype, {
            _cacheSelectors: function() {
                this.cache = {
                    $disclosureList: this.$container.find(b.disclosureList),
                    $disclosureToggle: this.$container.find(b.disclosureToggle),
                    $disclosureInput: this.$container.find(b.disclosureInput),
                    $disclosureOptions: this.$container.find(b.disclosureOptions)
                }
            },
            _connectToggle: function() {
                this.cache.$disclosureToggle.on("click", (function(a) {
                    var b = "true" === $(a.currentTarget).attr("aria-expanded");
                    $(a.currentTarget).attr("aria-expanded", !b),
                    this.cache.$disclosureList.toggleClass(c.listVisible)
                }
                ).bind(this))
            },
            _connectOptions: function() {
                this.cache.$disclosureOptions.on("click", (function(a) {
                    a.preventDefault(),
                    this._submitForm($(a.currentTarget).data("value"))
                }
                ).bind(this))
            },
            _onFocusOut: function() {
                this.cache.$disclosureToggle.on("focusout", (function(a) {
                    0 === this.$container.has(a.relatedTarget).length && this._hideList()
                }
                ).bind(this)),
                this.cache.$disclosureList.on("focusout", (function(a) {
                    var b = $(a.currentTarget).has(a.relatedTarget).length > 0;
                    this.cache.$disclosureList.hasClass(c.listVisible) && !b && this._hideList()
                }
                ).bind(this)),
                this.$container.on("keyup", (function(a) {
                    27 === a.which && (this._hideList(),
                    this.cache.$disclosureToggle.focus())
                }
                ).bind(this)),
                this.bodyOnClick = (function(a) {
                    var b = this.$container.has(a.target).length > 0;
                    this.cache.$disclosureList.hasClass(c.listVisible) && !b && this._hideList()
                }
                ).bind(this),
                $("body").on("click", this.bodyOnClick)
            },
            _submitForm: function(a) {
                this.cache.$disclosureInput.val(a),
                this.$container.parents("form").submit()
            },
            _hideList: function() {
                this.cache.$disclosureList.removeClass(c.listVisible),
                this.cache.$disclosureToggle.attr("aria-expanded", !1)
            },
            unload: function() {
                $("body").off("click", this.bodyOnClick),
                this.cache.$disclosureOptions.off(),
                this.cache.$disclosureToggle.off(),
                this.cache.$disclosureList.off(),
                this.$container.off()
            }
        }),
        a
    }(),
    theme.showQuickPopup = function(f, c) {
        var a = $('<div class="simple-popup"/>')
          , d = c.offset()
          , e = c[0].getBoundingClientRect().left;
        a.html(f).css({
            left: d.left,
            top: d.top
        }).hide(),
        $("body").append(a);
        var b = -(a.outerWidth() - c.outerWidth()) / 2;
        e + b < 0 && (b -= e + b - 2),
        a.css({
            marginTop: -a.outerHeight() - 10,
            marginLeft: b
        }),
        a.fadeIn(200).delay(3500).fadeOut(400, function() {
            $(this).remove()
        })
    }
    ,
    theme.scriptsLoaded = {},
    theme.loadScriptOnce = function(a, b, d, f) {
        if (void 0 === theme.scriptsLoaded[a]) {
            theme.scriptsLoaded[a] = [];
            var c = document.createElement("script");
            c.src = a,
            (f || d) && (c.async = !1),
            d && d(),
            "function" == typeof b && (theme.scriptsLoaded[a].push(b),
            c.readyState ? c.onreadystatechange = (function() {
                if ("loaded" == c.readyState || "complete" == c.readyState) {
                    c.onreadystatechange = null;
                    for (var a = 0; a < theme.scriptsLoaded[this].length; a++)
                        theme.scriptsLoaded[this][a]();
                    theme.scriptsLoaded[this] = !0
                }
            }
            ).bind(a) : c.onload = (function() {
                for (var a = 0; a < theme.scriptsLoaded[this].length; a++)
                    theme.scriptsLoaded[this][a]();
                theme.scriptsLoaded[this] = !0
            }
            ).bind(a));
            var e = document.getElementsByTagName("script")[0];
            return e.parentNode.insertBefore(c, e),
            !0
        }
        if ("object" != typeof theme.scriptsLoaded[a] || "function" != typeof b)
            return "function" == typeof b && b(),
            !1;
        theme.scriptsLoaded[a].push(b)
    }
    ,
    theme.loadStyleOnce = function(d) {
        var b = d.replace(/^https?:/, "");
        if (!document.querySelector('link[href="' + encodeURI(b) + '"]')) {
            var a = document.createElement("link");
            a.href = b,
            a.rel = "stylesheet",
            a.type = "text/css";
            var c = document.getElementsByTagName("link")[0];
            c.parentNode.insertBefore(a, c)
        }
    }
    ,
    $.fn.clickyBoxes = function(a) {
        if ("destroy" != a)
            return $(this).filter("select:not(.clickybox-replaced)").addClass("clickybox-replaced").each(function() {
                var a, b = b || $(this).attr("id"), c = $('<ul class="clickyboxes"/>').attr("id", "clickyboxes-" + b).data("select", $(this)).insertAfter(this);
                (a = $(this).is("[id]") ? $('label[for="' + $(this).attr("id") + '"]') : $(this).siblings("label")).length > 0 && c.addClass("options-" + removeDiacritics(a.text()).toLowerCase().replace(/'/g, "").replace(/[^a-z0-9]+/g, "-").replace(/-+/g, "-").replace(/-*$/, "")),
                $(this).find("option").each(function() {
                    $("<li/>").appendTo(c).append($('<a href="#"/>').attr("data-value", $(this).val()).attr("title", $(this).val()).addClass("opt--" + removeDiacritics($(this).text()).toLowerCase().replace(/'/g, "").replace(/[^a-z0-9]+/g, "-").replace(/-+/g, "-").replace(/-*$/, "")))
                }),
                $(this).hide().addClass("replaced").on("change.clickyboxes keyup.clickyboxes", function() {
                    var a = $(this).val();
                    c.find("a").removeClass("active").filter(function() {
                        return $(this).attr("data-value") == a
                    }).addClass("active")
                }).trigger("keyup"),
                c.on("click.clickyboxes", "a", function() {
                    if (!$(this).hasClass("active")) {
                        var a = $(this).closest(".clickyboxes");
                        a.data("select").val($(this).data("value")).trigger("change"),
                        a.trigger("change")
                    }
                    return !1
                })
            });
        $(this).off(".clickyboxes"),
        $(this).next(".clickyboxes").off(".clickyboxes")
    }
    ,
    $.fn.selectReplace = function(e) {
        if ("destroy" == e)
            $(this).off(".selectreplace");
        else {
            if (!$(this)[0] || "sort-by" != $(this)[0].id)
                return $(this).filter("select:not(.replaced, .noreplace)").addClass("replaced").each(function() {
                    var a = $(this).find("option")
                      , b = a.filter(":selected").length > 0 ? a.filter(":selected").text() : a.first().text();
                    $(this).wrap('<div class="pretty-select">').parent().addClass("id-" + $(this).attr("id")).append('<span class="text"><span class="value">' + b + '</span></span><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>').toggleClass("plaintext", $(this).hasClass("plaintext"))
                }).on("change.selectreplace keyup.selectreplace", function() {
                    $(this).siblings(".text").find(".value").html($(this).find(":selected").html())
                });
            var a = $(this)
              , f = $(this).children("option").length;
            if($('.custom_select').length){$('.custom_select').remove();}
            a.addClass("select-hidden"),
            a.wrap('<div class="select"></div>'),
            a.after('<div class="select-styled"></div>');
            var c = a.next("div.select-styled");
            c.text(a.children("option:selected").eq(0).text());
            for (var d = $("<ul />", {
                class: "select-options"
            }).insertAfter(c), b = 0; b < f; b++)
                $("<li />", {
                    text: a.children("option").eq(b).text(),
                    rel: a.children("option").eq(b).val()
                }).appendTo(d);
            var g = d.children("li");
            c.click(function(a) {
                a.stopPropagation(),
                $("div.select-styled.active").not(this).each(function() {
                    $(this).removeClass("active").next("ul.select-options").hide()
                }),
                $(this).toggleClass("active").next("ul.select-options").toggle()
            }),
            g.click(function(b) {
                b.stopPropagation(),
                c.text($(this).text()).removeClass("active"),
                a.val($(this).attr("rel")),
                a.trigger("change"),
                d.hide()
            }),
            $(document).click(function() {
                c.removeClass("active"),
                d.hide()
            })
        }
    }
    ,
    theme.debounce = function(a) {
        var b, c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 700, d = arguments.length > 2 ? arguments[2] : void 0;
        return function() {
            var e = this
              , f = arguments
              , g = function() {
                b = null,
                d || a.apply(e, f)
            }
              , h = d && !b;
            clearTimeout(b),
            b = setTimeout(g, c),
            h && a.apply(e, f)
        }
    }
    ,
    (i = document.createEvent("Event")).initEvent("throttled-scroll", !0, !0),
    window.addEventListener("scroll", function(a, b) {
        var c = -1
          , d = !1;
        return function() {
            clearTimeout(c),
            c = setTimeout(a, b),
            d || (a.call(),
            d = !0,
            setTimeout(function() {
                d = !1
            }, b))
        }
    }(function() {
        window.dispatchEvent(i)
    }, 200));
    class k {
        constructor(a, b) {
            this.$container = a,
            this.namespace = b,
            this.cssClasses = {
                visible: "cc-popup--visible",
                bodyNoScroll: "cc-popup-no-scroll",
                bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right"
            }
        }
        open(b) {
            if (this.$container.data("freeze-scroll")) {
                $("body").addClass(this.cssClasses.bodyNoScroll);
                var a = document.createElement("div");
                a.className = "popup-scrollbar-measure",
                document.body.appendChild(a);
                var c = a.getBoundingClientRect().width - a.clientWidth;
                document.body.removeChild(a),
                c > 0 && $("body").css("padding-right", c + "px").addClass(this.cssClasses.bodyNoScrollPadRight)
            }
            this.$container.addClass(this.cssClasses.visible),
            this.previouslyActiveElement = document.activeElement,
            setTimeout(()=>{
                this.$container.find(".cc-popup-close")[0].focus()
            }
            , 500),
            $(window).on("keydown" + this.namespace, a=>{
                27 === a.keyCode && this.close()
            }
            ),
            b && b()
        }
        close(b) {
            if (this.$container.removeClass(this.cssClasses.visible),
            this.previouslyActiveElement && $(this.previouslyActiveElement).focus(),
            $(window).off("keydown" + this.namespace),
            this.$container.data("freeze-scroll")) {
                var a = 500
                  , c = this.$container.find(".cc-popup-modal");
                c.length && (a = parseFloat(getComputedStyle(c[0]).transitionDuration)) && a > 0 && (a *= 1e3),
                setTimeout(()=>{
                    $("body").removeClass(this.cssClasses.bodyNoScroll).removeClass(this.cssClasses.bodyNoScrollPadRight).css("padding-right", "0")
                }
                , a)
            }
            b && b()
        }
    }
    (()=>{
        theme.initAnimateOnScroll = function() {
            if (document.body.classList.contains("cc-animate-enabled") && window.innerWidth >= 768) {
                var c = void 0 !== document.body.dataset.ccAnimateTimeout ? document.body.dataset.ccAnimateTimeout : 200;
                if ("IntersectionObserver"in window) {
                    var d = new IntersectionObserver((a,b)=>{
                        a.forEach(a=>{
                            a.isIntersecting && !a.target.classList.contains("cc-animate-complete") && (setTimeout(()=>{
                                a.target.classList.add("-in", "cc-animate-complete")
                            }
                            , c),
                            setTimeout(()=>{
                                a.target.classList.remove("data-cc-animate"),
                                a.target.style.transitionDuration = null,
                                a.target.style.transitionDelay = null
                            }
                            , 5e3),
                            b.unobserve(a.target))
                        }
                        )
                    }
                    );
                    document.querySelectorAll("[data-cc-animate]:not(.cc-animate-init)").forEach(a=>{
                        a.dataset.ccAnimateDelay && (a.style.transitionDelay = a.dataset.ccAnimateDelay),
                        a.dataset.ccAnimateDuration && (a.style.transitionDuration = a.dataset.ccAnimateDuration),
                        a.dataset.ccAnimate && a.classList.add(a.dataset.ccAnimate),
                        a.classList.add("cc-animate-init"),
                        d.observe(a)
                    }
                    )
                } else
                    for (var b = document.querySelectorAll("[data-cc-animate]:not(.cc-animate-init)"), a = 0; a < b.length; a++)
                        b[a].classList.add("-in", "cc-animate-complete")
            }
        }
        ,
        theme.initAnimateOnScroll(),
        document.addEventListener("shopify:section:load", ()=>{
            setTimeout(theme.initAnimateOnScroll, 100)
        }
        );
        try {
            window.matchMedia("(min-width: 768px)").addEventListener("change", a=>{
                a.matches && setTimeout(theme.initAnimateOnScroll, 100)
            }
            )
        } catch (a) {}
    }
    )();
    class l {
        constructor(a) {
            this.container = a,
            this.selectors = {
                inputMin: ".cc-price-range__input--min",
                inputMax: ".cc-price-range__input--max",
                control: ".cc-price-range__control",
                controlMin: ".cc-price-range__control--min",
                controlMax: ".cc-price-range__control--max",
                bar: ".cc-price-range__bar",
                activeBar: ".cc-price-range__bar-active"
            },
            this.controls = {
                min: {
                    barControl: a.querySelector(this.selectors.controlMin),
                    input: a.querySelector(this.selectors.inputMin)
                },
                max: {
                    barControl: a.querySelector(this.selectors.controlMax),
                    input: a.querySelector(this.selectors.inputMax)
                }
            },
            this.controls.min.value = parseInt("" === this.controls.min.input.value ? this.controls.min.input.placeholder : this.controls.min.input.value),
            this.controls.max.value = parseInt("" === this.controls.max.input.value ? this.controls.max.input.placeholder : this.controls.max.input.value),
            this.valueMin = this.controls.min.input.min,
            this.valueMax = this.controls.min.input.max,
            this.valueRange = this.valueMax - this.valueMin,
            [this.controls.min, this.controls.max].forEach(a=>{
                a.barControl.setAttribute("aria-valuemin", this.valueMin),
                a.barControl.setAttribute("aria-valuemax", this.valueMax),
                a.barControl.setAttribute("tabindex", 0)
            }
            ),
            this.controls.min.barControl.setAttribute("aria-valuenow", this.controls.min.value),
            this.controls.max.barControl.setAttribute("aria-valuenow", this.controls.max.value),
            this.bar = a.querySelector(this.selectors.bar),
            this.activeBar = a.querySelector(this.selectors.activeBar),
            this.inDrag = !1,
            this.bindEvents(),
            this.render()
        }
        getPxToValueRatio() {
            return this.bar.clientWidth / (this.valueMax - this.valueMin)
        }
        getPcToValueRatio() {
            return 100 / (this.valueMax - this.valueMin)
        }
        setActiveControlValue(a) {
            isNaN(parseInt(a)) || (this.activeControl === this.controls.min ? ("" === a && (a = this.valueMin),
            a = Math.max(this.valueMin, a),
            a = Math.min(a, this.controls.max.value)) : ("" === a && (a = this.valueMax),
            a = Math.min(this.valueMax, a),
            a = Math.max(a, this.controls.min.value)),
            this.activeControl.value = Math.round(a),
            this.activeControl.input.value != this.activeControl.value && (this.activeControl.value == this.activeControl.input.placeholder ? this.activeControl.input.value = "" : this.activeControl.input.value = this.activeControl.value,
            this.activeControl.input.dispatchEvent(new CustomEvent("change",{
                bubbles: !0,
                cancelable: !1,
                detail: {
                    sender: "theme:component:price_range"
                }
            }))),
            this.activeControl.barControl.setAttribute("aria-valuenow", this.activeControl.value))
        }
        render() {
            this.drawControl(this.controls.min),
            this.drawControl(this.controls.max),
            this.drawActiveBar()
        }
        drawControl(a) {
            a.barControl.style.left = (a.value - this.valueMin) * this.getPcToValueRatio() + "%"
        }
        drawActiveBar() {
            this.activeBar.style.left = (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() + "%",
            this.activeBar.style.right = (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() + "%"
        }
        handleControlTouchStart(a) {
            a.preventDefault(),
            this.startDrag(a.target, a.touches[0].clientX),
            this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this),
            this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this),
            window.addEventListener("touchmove", this.boundControlTouchMoveEvent),
            window.addEventListener("touchend", this.boundControlTouchEndEvent)
        }
        handleControlTouchMove(a) {
            this.moveDrag(a.touches[0].clientX)
        }
        handleControlTouchEnd(a) {
            a.preventDefault(),
            window.removeEventListener("touchmove", this.boundControlTouchMoveEvent),
            window.removeEventListener("touchend", this.boundControlTouchEndEvent),
            this.stopDrag()
        }
        handleControlMouseDown(a) {
            a.preventDefault(),
            this.startDrag(a.target, a.clientX),
            this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this),
            this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this),
            window.addEventListener("mousemove", this.boundControlMouseMoveEvent),
            window.addEventListener("mouseup", this.boundControlMouseUpEvent)
        }
        handleControlMouseMove(a) {
            this.moveDrag(a.clientX)
        }
        handleControlMouseUp(a) {
            a.preventDefault(),
            window.removeEventListener("mousemove", this.boundControlMouseMoveEvent),
            window.removeEventListener("mouseup", this.boundControlMouseUpEvent),
            this.stopDrag()
        }
        startDrag(a, b) {
            this.controls.min.barControl === a ? this.activeControl = this.controls.min : this.activeControl = this.controls.max,
            this.dragStartX = b,
            this.dragStartValue = this.activeControl.value,
            this.inDrag = !0
        }
        moveDrag(a) {
            if (this.inDrag) {
                var b = this.dragStartValue + (a - this.dragStartX) / this.getPxToValueRatio();
                this.setActiveControlValue(b),
                this.render()
            }
        }
        stopDrag() {
            this.inDrag = !1
        }
        handleControlKeyDown(a) {
            "ArrowRight" === a.key ? this.incrementControlFromKeypress(a.target, 10) : "ArrowLeft" === a.key && this.incrementControlFromKeypress(a.target, -10)
        }
        incrementControlFromKeypress(a, b) {
            this.controls.min.barControl === a ? this.activeControl = this.controls.min : this.activeControl = this.controls.max,
            this.setActiveControlValue(this.activeControl.value + b / this.getPxToValueRatio()),
            this.render()
        }
        handleInputChange(a) {
            a.target.value = a.target.value.replace(/\D/g, ""),
            a.detail && "theme:component:price_range" == a.detail.sender || (this.controls.min.input === a.target ? this.activeControl = this.controls.min : this.activeControl = this.controls.max,
            this.setActiveControlValue(a.target.value),
            this.render())
        }
        handleInputKeyup(a) {
            setTimeout((function() {
                this.value = this.value.replace(/\D/g, "")
            }
            ).bind(a.target), 10)
        }
        bindEvents() {
            [this.controls.min, this.controls.max].forEach(a=>{
                a.barControl.addEventListener("touchstart", this.handleControlTouchStart.bind(this)),
                a.barControl.addEventListener("mousedown", this.handleControlMouseDown.bind(this)),
                a.barControl.addEventListener("keydown", this.handleControlKeyDown.bind(this)),
                a.input.addEventListener("change", this.handleInputChange.bind(this)),
                a.input.addEventListener("keyup", this.handleInputKeyup.bind(this))
            }
            )
        }
        destroy() {}
    }
    new class extends j {
        constructor() {
            var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "price-range"
              , b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(a);
            super(a, b)
        }
        init(a) {
            super.init(a),
            this.registerInstance(a, new l(a))
        }
        destroy(a) {
            this.destroyInstance(a),
            super.destroy(a)
        }
    }
    ;
    class m {
        constructor(a) {
            this.accordion = a,
            this.itemClass = ".cc-accordion-item",
            this.titleClass = ".cc-accordion-item__title",
            this.panelClass = ".cc-accordion-item__panel",
            this.allowMultiOpen = "true" === this.accordion.dataset.allowMultiOpen,
            this.allowMultiOpen || (this.activeItem = this.accordion.querySelector("".concat(this.itemClass, "[open]"))),
            this.bindEvents()
        }
        static addPanelHeight(a) {
            a.style.height = "".concat(a.scrollHeight, "px")
        }
        static removePanelHeight(a) {
            a.getAttribute("style"),
            a.removeAttribute("style")
        }
        open(a, b) {
            if (b.style.height = "0",
            a.open = !0,
            m.addPanelHeight(b),
            setTimeout(()=>{
                a.classList.add("is-open")
            }
            , 10),
            !this.allowMultiOpen) {
                if (this.activeItem && this.activeItem !== a) {
                    var c = this.activeItem.querySelector(this.panelClass);
                    this.close(this.activeItem, c)
                }
                this.activeItem = a
            }
        }
        close(a, b) {
            m.addPanelHeight(b),
            a.classList.remove("is-open"),
            a.classList.add("is-closing"),
            this.activeItem === a && (this.activeItem = null),
            setTimeout(()=>{
                b.style.height = "0"
            }
            , 10)
        }
        handleClick(c) {
            var a = c.target.closest(this.titleClass);
            if (a) {
                c.preventDefault();
                var b = a.parentNode
                  , d = a.nextElementSibling;
                b.open ? this.close(b, d) : this.open(b, d)
            }
        }
        handleTransition(b) {
            if (b.target.matches(this.panelClass)) {
                var c = b.target
                  , a = c.parentNode;
                a.classList.contains("is-closing") && (a.classList.remove("is-closing"),
                a.open = !1),
                m.removePanelHeight(c)
            }
        }
        bindEvents() {
            this.clickHandler = this.handleClick.bind(this),
            this.transitionHandler = this.handleTransition.bind(this),
            this.accordion.addEventListener("click", this.clickHandler),
            this.accordion.addEventListener("transitionend", this.transitionHandler)
        }
        destroy() {
            this.accordion.removeEventListener("click", this.clickHandler),
            this.accordion.removeEventListener("transitionend", this.transitionHandler)
        }
    }
    new class extends j {
        constructor() {
            var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "accordion"
              , b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(a);
            super(a, b)
        }
        init(a) {
            super.init(a),
            this.registerInstance(a, new m(a))
        }
        destroy(a) {
            this.destroyInstance(a),
            super.destroy(a)
        }
    }
    ,
    theme.VideoManager = new function() {
        var _ = this;
        _._permitPlayback = function(a) {
            return !($(a).hasClass("video-container--background") && 768 > $(window).outerWidth())
        }
        ,
        _.youtubeVars = {
            incrementor: 0,
            apiReady: !1,
            videoData: {},
            toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)'
        },
        _.youtubeApiReady = function() {
            _.youtubeVars.apiReady = !0,
            _._loadYoutubeVideos()
        }
        ,
        _._loadYoutubeVideos = function(a) {
            $(_.youtubeVars.toProcessSelector, a).length && (_.youtubeVars.apiReady ? $(_.youtubeVars.toProcessSelector, a).each(function() {
                if (_._permitPlayback($(this))) {
                    $(this).addClass("video--init"),
                    _.youtubeVars.incrementor++;
                    var a = "theme-yt-video-" + _.youtubeVars.incrementor;
                    $(this).data("video-container-id", a);
                    var d = $('<div class="video-container__video-element">').attr("id", a).appendTo($(".video-container__video", this))
                      , c = $(this).data("video-autoplay")
                      , b = $(this).data("video-loop")
                      , e = new YT.Player(a,{
                        height: "360",
                        width: "640",
                        videoId: $(this).data("video-id"),
                        playerVars: {
                            iv_load_policy: 3,
                            modestbranding: 1,
                            autoplay: 0,
                            loop: b ? 1 : 0,
                            playlist: $(this).data("video-id"),
                            rel: 0,
                            showinfo: 0
                        },
                        events: {
                            onReady: _._onYoutubePlayerReady.bind({
                                autoplay: c,
                                loop: b,
                                $container: $(this)
                            }),
                            onStateChange: _._onYoutubePlayerStateChange.bind({
                                autoplay: c,
                                loop: b,
                                $container: $(this)
                            })
                        }
                    });
                    _.youtubeVars.videoData[a] = {
                        id: a,
                        container: this,
                        videoElement: d,
                        player: e
                    }
                }
            }) : theme.loadScriptOnce("https://www.youtube.com/iframe_api"))
        }
        ,
        _._onYoutubePlayerReady = function(a) {
            a.target.setPlaybackQuality("hd1080"),
            this.autoplay && (a.target.mute(),
            a.target.playVideo()),
            _._initBackgroundVideo(this.$container)
        }
        ,
        _._onYoutubePlayerStateChange = function(a) {
            if (a.data == YT.PlayerState.PLAYING && (this.$container.addClass("video--play-started"),
            this.autoplay && a.target.mute(),
            this.loop)) {
                var b = a.target.getDuration() - 1;
                if (b > 2) {
                    function c() {
                        a.target.getCurrentTime() > b && a.target.seekTo(0),
                        setTimeout(c, 250)
                    }
                    c()
                }
            }
        }
        ,
        _._unloadYoutubeVideos = function(c) {
            for (var a in _.youtubeVars.videoData) {
                var b = _.youtubeVars.videoData[a];
                if ($(c).find(b.container).length) {
                    b.player.destroy(),
                    delete _.youtubeVars.videoData[a];
                    return
                }
            }
        }
        ,
        _.vimeoVars = {
            incrementor: 0,
            apiReady: !1,
            videoData: {},
            toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)'
        },
        _.vimeoApiReady = function() {
            _.vimeoVars.apiReady = !0,
            _._loadVimeoVideos()
        }
        ,
        _._loadVimeoVideos = function(a) {
            $(_.vimeoVars.toProcessSelector, a).length && (_.vimeoVars.apiReady ? $(_.vimeoVars.toProcessSelector, a).each(function() {
                if (_._permitPlayback($(this))) {
                    $(this).addClass("video--init"),
                    _.vimeoVars.incrementor++;
                    var d = $(this)
                      , a = "theme-vi-video-" + _.vimeoVars.incrementor;
                    $(this).data("video-container-id", a);
                    var e = $('<div class="video-container__video-element">').attr("id", a).appendTo($(".video-container__video", this))
                      , b = !!$(this).data("video-autoplay")
                      , c = new Vimeo.Player(a,{
                        url: $(this).data("video-url"),
                        width: 640,
                        loop: $(this).data("video-autoplay"),
                        autoplay: b,
                        muted: d.hasClass("video-container--background") || b
                    });
                    c.on("playing", (function() {
                        $(this).addClass("video--play-started")
                    }
                    ).bind(this)),
                    c.ready().then(function() {
                        if (b && (c.setVolume(0),
                        c.play()),
                        c.element && c.element.width && c.element.height) {
                            var a = parseInt(c.element.height) / parseInt(c.element.width);
                            d.find(".video-container__video").css("padding-bottom", 100 * a + "%")
                        }
                        _._initBackgroundVideo(d)
                    }),
                    _.vimeoVars.videoData[a] = {
                        id: a,
                        container: this,
                        videoElement: e,
                        player: c,
                        autoPlay: b
                    }
                }
            }) : window.define ? theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function() {
                _.vimeoVars.apiReady = !0,
                _._loadVimeoVideos(),
                window.define = window.tempDefine
            }, function() {
                window.tempDefine = window.define,
                window.define = null
            }) : theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function() {
                _.vimeoVars.apiReady = !0,
                _._loadVimeoVideos()
            }))
        }
        ,
        _._unloadVimeoVideos = function(c) {
            for (var a in _.vimeoVars.videoData) {
                var b = _.vimeoVars.videoData[a];
                if ($(c).find(b.container).length) {
                    b.player.unload(),
                    delete _.vimeoVars.videoData[a];
                    return
                }
            }
        }
        ,
        _._loadThirdPartyApis = function(a) {
            _._permitPlayback($(".video-container", a)) && (_._loadYoutubeVideos(a),
            _._loadVimeoVideos(a))
        }
        ,
        _.mp4Vars = {
            incrementor: 0,
            videoData: {},
            toProcessSelector: '.video-container[data-video-type="mp4"]:not(.video--init)'
        },
        _._loadMp4Videos = function(a) {
            $(_.mp4Vars.toProcessSelector, a).length && $(_.mp4Vars.toProcessSelector, a).addClass("video--init").each(function() {
                _.mp4Vars.incrementor++,
                $(this);
                var b = "theme-mp-video-" + _.mp4Vars.incrementor;
                $(this).data("video-container-id", b);
                var c = $('<div class="video-container__video-element">').attr("id", b).appendTo($(".video-container__video", this))
                  , a = $("<video playsinline>");
                $(this).data("video-loop") && a.attr("loop", "loop"),
                $(this).hasClass("video-container--background") || a.attr("controls", "controls"),
                $(this).data("video-autoplay") && (a.attr({
                    autoplay: "autoplay",
                    muted: "muted"
                }),
                a[0].muted = !0,
                a.one("loadeddata", function() {
                    this.play()
                })),
                a.on("playing", (function() {
                    $(this).addClass("video--play-started")
                }
                ).bind(this)),
                a.attr("src", $(this).data("video-url")).appendTo(c),
                _.mp4Vars.videoData[b] = {
                    element: a[0]
                }
            })
        }
        ,
        _._unloadMp4Videos = function(a) {}
        ,
        _._initBackgroundVideo = function(a) {
            if (a.hasClass("video-container--background") && a.find(".video-container__video iframe").length) {
                function b() {
                    var e = $(".video-container__media", this)
                      , f = e.length ? e : this
                      , b = f.width()
                      , d = f.height()
                      , k = b / d
                      , g = $(".video-container__video iframe", this)
                      , c = g.attr("width") / g.attr("height")
                      , h = $(".video-container__video", this)
                      , a = 75;
                    if (k > c) {
                        var i = b / c + 2 * a;
                        h.css({
                            marginTop: (d - i) / 2 - a,
                            marginLeft: "",
                            height: i + 2 * a,
                            width: ""
                        })
                    } else {
                        var j = b * c + 2 * a * c;
                        h.css({
                            marginTop: -a,
                            marginLeft: (b - j) / 2,
                            height: d + 2 * a,
                            width: j
                        })
                    }
                }
                b.bind(a)(),
                $(window).on("debouncedresize." + a.data("video-container-id"), b.bind(a))
            }
        }
        ,
        this.onSectionLoad = function(a) {
            $(".video-container[data-video-url]:not([data-video-type])").each(function() {
                var a = $(this).data("video-url");
                a.indexOf(".mp4") > -1 && $(this).attr("data-video-type", "mp4"),
                a.indexOf("vimeo.com") > -1 && ($(this).attr("data-video-type", "vimeo"),
                $(this).attr("data-video-id", a.split("?")[0].split("/").pop())),
                (a.indexOf("youtu.be") > -1 || a.indexOf("youtube.com") > -1) && ($(this).attr("data-video-type", "youtube"),
                a.indexOf("v=") > -1 ? $(this).attr("data-video-id", a.split("v=").pop().split("&")[0]) : $(this).attr("data-video-id", a.split("?")[0].split("/").pop()))
            }),
            _._loadThirdPartyApis(a),
            _._loadMp4Videos(a),
            $(window).on("debouncedresize.video-manager-resize", function() {
                _._loadThirdPartyApis(a)
            }),
            $(".video-container__play", a).on("click", function(d) {
                d.preventDefault();
                var c = $(this).closest(".video-container");
                c.addClass("video-container--playing"),
                $(a).trigger("cc:video:play");
                var b = c.data("video-container-id");
                0 === b.indexOf("theme-yt-video") ? _.youtubeVars.videoData[b].player.playVideo() : 0 === b.indexOf("theme-vi-video") ? _.vimeoVars.videoData[b].player.play() : 0 === b.indexOf("theme-mp-video") && _.mp4Vars.videoData[b].element.play()
            }),
            $(".video-container__stop", a).on("click", function(d) {
                d.preventDefault();
                var c = $(this).closest(".video-container");
                c.removeClass("video-container--playing"),
                $(a).trigger("cc:video:stop");
                var b = c.data("video-container-id");
                0 === b.indexOf("theme-yt-video") ? _.youtubeVars.videoData[b].player.stopVideo() : (_.vimeoVars.videoData[b].player.pause(),
                _.vimeoVars.videoData[b].player.setCurrentTime(0))
            })
        }
        ,
        this.onSectionUnload = function(a) {
            $(".video-container__play, .video-container__stop", a).off("click"),
            $(window).off("." + $(".video-container").data("video-container-id")),
            $(window).off("debouncedresize.video-manager-resize"),
            _._unloadYoutubeVideos(a),
            _._unloadVimeoVideos(a),
            _._unloadMp4Videos(a),
            $(a).trigger("cc:video:stop")
        }
    }
    ,
    window.onYouTubeIframeAPIReady = function() {
        theme.VideoManager.youtubeApiReady()
    }
    ,
    b.sections.push({
        name: "video",
        section: theme.VideoManager
    }),
    theme.MapSection = new function() {
        var _ = this;
        _.config = {
            zoom: 14,
            styles: {
                default: [],
                silver: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#f5f5f5"
                    }]
                }, {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#f5f5f5"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#bdbdbd"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#eeeeee"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e5e5e5"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#ffffff"
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dadada"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e5e5e5"
                    }]
                }, {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [{
                        color: "#eeeeee"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#c9c9c9"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }],
                retro: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#ebe3cd"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#523735"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#f5f1e6"
                    }]
                }, {
                    featureType: "administrative",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#c9b2a6"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#dcd2be"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#ae9e90"
                    }]
                }, {
                    featureType: "landscape.natural",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dfd2ae"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dfd2ae"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#93817c"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#a5b076"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#447530"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#f5f1e6"
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [{
                        color: "#fdfcf8"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#f8c967"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#e9bc62"
                    }]
                }, {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e98d58"
                    }]
                }, {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#db8555"
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#806b63"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dfd2ae"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#8f7d77"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#ebe3cd"
                    }]
                }, {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [{
                        color: "#dfd2ae"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#b9d3c2"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#92998d"
                    }]
                }],
                dark: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#212121"
                    }]
                }, {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#212121"
                    }]
                }, {
                    featureType: "administrative",
                    elementType: "geometry",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "administrative.country",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9e9e9e"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    featureType: "administrative.locality",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#bdbdbd"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#181818"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1b1b1b"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#2c2c2c"
                    }]
                }, {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#8a8a8a"
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [{
                        color: "#373737"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#3c3c3c"
                    }]
                }, {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry",
                    stylers: [{
                        color: "#4e4e4e"
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#616161"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#757575"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#000000"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#3d3d3d"
                    }]
                }],
                night: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#242f3e"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#746855"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#242f3e"
                    }]
                }, {
                    featureType: "administrative.locality",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#d59563"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#d59563"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#263c3f"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#6b9a76"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#38414e"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#212a37"
                    }]
                }, {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#9ca5b3"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#746855"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#1f2835"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#f3d19c"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "geometry",
                    stylers: [{
                        color: "#2f3948"
                    }]
                }, {
                    featureType: "transit.station",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#d59563"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#17263c"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#515c6d"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#17263c"
                    }]
                }],
                aubergine: [{
                    elementType: "geometry",
                    stylers: [{
                        color: "#1d2c4d"
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#8ec3b9"
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1a3646"
                    }]
                }, {
                    featureType: "administrative.country",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#4b6878"
                    }]
                }, {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#64779e"
                    }]
                }, {
                    featureType: "administrative.province",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#4b6878"
                    }]
                }, {
                    featureType: "landscape.man_made",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#334e87"
                    }]
                }, {
                    featureType: "landscape.natural",
                    elementType: "geometry",
                    stylers: [{
                        color: "#023e58"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#283d6a"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#6f9ba5"
                    }]
                }, {
                    featureType: "poi",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1d2c4d"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#023e58"
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#3C7680"
                    }]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{
                        color: "#304a7d"
                    }]
                }, {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#98a5be"
                    }]
                }, {
                    featureType: "road",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1d2c4d"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{
                        color: "#2c6675"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#255763"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#b0d5ce"
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#023e58"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#98a5be"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "labels.text.stroke",
                    stylers: [{
                        color: "#1d2c4d"
                    }]
                }, {
                    featureType: "transit.line",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#283d6a"
                    }]
                }, {
                    featureType: "transit.station",
                    elementType: "geometry",
                    stylers: [{
                        color: "#3a4762"
                    }]
                }, {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#0e1626"
                    }]
                }, {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{
                        color: "#4e6d70"
                    }]
                }]
            }
        },
        _.apiStatus = null,
        this.geolocate = function(a) {
            var b = $.Deferred()
              , c = new google.maps.Geocoder
              , d = a.data("address-setting");
            return c.geocode({
                address: d
            }, function(c, a) {
                a !== google.maps.GeocoderStatus.OK && b.reject(a),
                b.resolve(c)
            }),
            b
        }
        ,
        this.createMap = function(a) {
            var b = $(".map-section__map-container", a);
            return _.geolocate(b).then((function(c) {
                var d = {
                    zoom: _.config.zoom,
                    styles: _.config.styles[$(a).data("map-style")],
                    center: c[0].geometry.location,
                    scrollwheel: !1,
                    disableDoubleClickZoom: !0,
                    disableDefaultUI: !0,
                    zoomControl: !0
                };
                _.map = new google.maps.Map(b[0],d),
                _.center = _.map.getCenter(),
                new google.maps.Marker({
                    map: _.map,
                    position: _.center,
                    clickable: !1
                }),
                google.maps.event.addDomListener(window, "resize", function() {
                    google.maps.event.trigger(_.map, "resize"),
                    _.map.setCenter(_.center)
                })
            }
            ).bind(this)).fail(function() {
                var a;
                switch (status) {
                case "ZERO_RESULTS":
                    a = theme.strings.addressNoResults;
                    break;
                case "OVER_QUERY_LIMIT":
                    a = theme.strings.addressQueryLimit;
                    break;
                default:
                    a = theme.strings.addressError
                }
                if (Shopify.designMode) {
                    var c = b.parents(".map-section");
                    c.addClass("page-width map-section--load-error"),
                    c.find(".map-section__wrapper").html('<div class="errors text-center">' + a + "</div>")
                }
            })
        }
        ,
        this.onSectionLoad = function(b) {
            var c = $(b);
            window.gm_authFailure = function() {
                Shopify.designMode && (c.addClass("page-width map-section--load-error"),
                c.find(".map-section__wrapper").html('<div class="errors text-center">' + theme.strings.authError + "</div>"))
            }
            ;
            var a = c.data("api-key");
            "string" == typeof a && "" !== a && theme.loadScriptOnce("https://maps.googleapis.com/maps/api/js?key=" + a, function() {
                _.createMap(c)
            })
        }
        ,
        this.onSectionUnload = function(a) {
            void 0 !== window.google && void 0 !== google.maps && google.maps.event.clearListeners(_.map, "resize")
        }
    }
    ,
    b.sections.push({
        name: "map",
        section: theme.MapSection
    }),
    theme.Popup = new function() {
        var a = "cc-theme-popup-dismissed";
        this.onSectionLoad = function(c) {
            this.namespace = theme.namespaceFromSection(c),
            this.$container = $(c),
            this.popup = new k(this.$container,this.namespace);
            var f = this.$container.data("dismiss-for-days")
              , d = this.$container.data("delay-seconds")
              , b = !0
              , g = this.$container.data("test-mode")
              , e = window.localStorage.getItem(a);
            e && (new Date().getTime() - e) / 864e5 < f && (b = !1),
            this.$container.find(".cc-popup-form__response").length && (b = !0,
            d = 1,
            this.$container.find(".cc-popup-form__response--success").length && this.functions.popupSetAsDismissed.call(this)),
            document.querySelector(".shopify-challenge__container") && (b = !1),
            (b || g) && setTimeout(()=>{
                this.popup.open()
            }
            , 1e3 * d),
            this.$container.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", ()=>{
                this.popup.close(()=>{
                    this.functions.popupSetAsDismissed.call(this)
                }
                )
            }
            )
        }
        ,
        this.onSectionSelect = function() {
            this.popup.open()
        }
        ,
        this.functions = {
            popupSetAsDismissed: function() {
                window.localStorage.setItem(a, new Date().getTime())
            }
        },
        this.onSectionUnload = function() {
            this.$container.off(this.namespace)
        }
    }
    ,
    b.sections.push({
        name: "newsletter-popup",
        section: theme.Popup
    }),
    theme.StoreAvailability = function(a) {
        var b = "store-availability-loading"
          , c = "cc-location";
        this.onSectionLoad = function(a) {
            this.namespace = theme.namespaceFromSection(a),
            this.$container = $(a),
            this.productId = this.$container.data("store-availability-container"),
            this.sectionUrl = this.$container.data("section-url"),
            this.$modal,
            this.$container.addClass("store-availability-initialized"),
            this.transitionDurationMS = 1e3 * parseFloat(getComputedStyle(a).transitionDuration),
            this.removeFixedHeightTimeout = -1,
            $(window).on("cc-variant-updated".concat(this.namespace).concat(this.productId), (b,a)=>{
                a.product.id === this.productId && this.functions.updateContent.bind(this)(a.variant ? a.variant.id : null, a.product.title, this.$container.data("has-only-default-variant"), a.variant && void 0 !== a.variant.available)
            }
            ),
            this.$container.data("single-variant-id") && this.functions.updateContent.bind(this)(this.$container.data("single-variant-id"), this.$container.data("single-variant-product-title"), this.$container.data("has-only-default-variant"), this.$container.data("single-variant-product-available"))
        }
        ,
        this.onSectionUnload = function() {
            $(window).off("cc-variant-updated".concat(this.namespace).concat(this.productId)),
            this.$container.off("click"),
            this.$modal && this.$modal.off("click")
        }
        ,
        this.functions = {
            getUserLocation: function() {
                return new Promise((b,d)=>{
                    var a;
                    sessionStorage[c] && (a = JSON.parse(sessionStorage[c])),
                    a ? b(a) : navigator.geolocation ? navigator.geolocation.getCurrentPosition(function(d) {
                        var a = {
                            latitude: d.coords.latitude,
                            longitude: d.coords.longitude
                        };
                        fetch("/localization.json", {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(a)
                        }),
                        sessionStorage[c] = JSON.stringify(a),
                        b(a)
                    }, function() {
                        b(!1)
                    }, {
                        maximumAge: 36e5,
                        timeout: 5e3
                    }) : b(!1)
                }
                )
            },
            getAvailableStores: function(a, b) {
                return $.get(this.sectionUrl.replace("VARIANT_ID", a), b)
            },
            calculateDistance: function(b, c, g) {
                var a = Math.PI / 180
                  , d = b.latitude * a
                  , h = b.longitude * a
                  , e = c.latitude * a
                  , f = Math.pow(Math.sin((d - e) / 2), 2) + Math.cos(d) * Math.cos(e) * Math.pow(Math.sin((h - c.longitude * a) / 2), 2);
                return ("metric" === g ? 6378.14 : 3959) * (2 * Math.atan2(Math.sqrt(f), Math.sqrt(1 - f)))
            },
            updateLocationDistances: function(a) {
                var b = this.$modal.find("[data-unit-system]").data("unit-system")
                  , c = this;
                this.$modal.find('[data-distance="false"]').each(function() {
                    var d = {
                        latitude: parseFloat($(this).data("latitude")),
                        longitude: parseFloat($(this).data("longitude"))
                    };
                    if (d.latitude && d.longitude) {
                        var e = c.functions.calculateDistance(a, d, b).toFixed(1);
                        $(this).html(e),
                        setTimeout(()=>{
                            $(this).closest(".store-availability-list__location__distance").addClass("-in")
                        }
                        , 0)
                    }
                    $(this).attr("data-distance", "true")
                })
            },
            updateContent: function(c, d, e, a) {
                this.$container.off("click", "[data-store-availability-modal-open]"),
                this.$container.off("click" + this.namespace, ".cc-popup-close, .cc-popup-background"),
                $(".store-availabilities-modal").remove(),
                a ? (this.$container.addClass(b),
                this.transitionDurationMS > 0 && this.$container.css("height", this.$container.outerHeight() + "px")) : (this.$container.addClass(b),
                this.transitionDurationMS > 0 && this.$container.css("height", "0px")),
                a && this.functions.getAvailableStores.call(this, c, a=>{
                    if (a.trim().length > 0 && !a.includes("NO_PICKUP")) {
                        this.$container.html(a),
                        this.$container.html(this.$container.children().first().html()),
                        this.$container.find("[data-store-availability-modal-product-title]").html(d),
                        e && this.$container.find(".store-availabilities-modal__variant-title").remove(),
                        this.$container.find(".cc-popup").appendTo("body"),
                        this.$modal = $("body").find(".store-availabilities-modal");
                        var g = new k(this.$modal,this.namespace);
                        if (this.$container.on("click", "[data-store-availability-modal-open]", ()=>(g.open(),
                        this.functions.getUserLocation().then(a=>{
                            a && this.$modal.find('[data-distance="false"]').length && this.functions.getAvailableStores.call(this, c, b=>{
                                this.$modal.find(".store-availabilities-list").html($(b).find(".store-availabilities-list").html()),
                                this.functions.updateLocationDistances.bind(this)(a)
                            }
                            )
                        }
                        ),
                        !1)),
                        this.$modal.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", ()=>{
                            g.close()
                        }
                        ),
                        this.$container.removeClass(b),
                        this.transitionDurationMS > 0) {
                            var f = this.$container.find(".store-availability-container").outerHeight();
                            this.$container.css("height", f > 0 ? f + "px" : ""),
                            clearTimeout(this.removeFixedHeightTimeout),
                            this.removeFixedHeightTimeout = setTimeout(()=>{
                                this.$container.css("height", "")
                            }
                            , this.transitionDurationMS)
                        }
                    }
                }
                )
            }
        },
        this.onSectionLoad(a)
    }
    ,
    b.sections.push({
        name: "store-availability",
        section: theme.StoreAvailability
    }),
    theme.icons = {
        left: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
        right: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
        close: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
        chevronLeft: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg>',
        chevronRight: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg>',
        tick: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>'
    },
    theme.viewport = {
        isXs: ()=>768 > $(window).outerWidth(),
        isSm: ()=>$(window).outerWidth() >= 768,
        isMd: ()=>$(window).outerWidth() >= 992,
        isLg: ()=>$(window).outerWidth() >= 1200,
        scrollTo: function(a) {
            var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1
              , d = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e3
              , c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0
              , e = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
            a && "string" == typeof a && (a = $(a)),
            e && (c += $("#toolbar").outerHeight()),
            -1 === b && a && a.length && (b = a.offset().top - c),
            $("html,body").animate({
                scrollTop: b
            }, d)
        }
    },
    theme.browser = {
        isSafari: ()=>-1 != navigator.userAgent.indexOf("Safari") && -1 == navigator.userAgent.indexOf("Chrome")
    },
    theme.device = {
        isTouch() {
            try {
                return document.createEvent("TouchEvent"),
                !0
            } catch (a) {
                return !1
            }
        }
    };
    try {
        theme.Shopify.features = JSON.parse(document.documentElement.querySelector("#shopify-features").textContent)
    } catch (n) {
        theme.Shopify.features = {}
    }
    if (theme.productData = {},
    !theme.imageLazyLoader) {
        for (var d = document.querySelectorAll('img[loading="lazy"][data-lazy-src],[data-lazy-bg]'), c = 0; c < d.length; c++) {
            var a = d[c]
              , e = a.clientWidth ? a.clientWidth : 500
              , f = a.getAttribute("data-lazy-src");
            if (f)
                a.setAttribute("src", f.replace("{width}x", e + "x"));
            else {
                var g = a.getAttribute("data-lazy-bg");
                g && (a.style.backgroundImage = "url(" + g.replace("{width}x", e + "x") + ")")
            }
        }
        theme.imageLazyLoader = {
            loadLazyImage() {},
            loadLazyImages() {}
        }
    }
    theme.namespaceFromSection = function(a) {
        return [".", $(a).data("section-type"), $(a).data("section-id")].join("")
    }
    ,
    theme.initContentSlider = function(a, c) {
        var d = $(".slideshow .slide", a).length - 1
          , b = "instant" == $(this).data("transition") ? 0 : 1e3;
        $(this).data("transition-speed") && (b = $(this).data("transition-speed")),
        $(".slideshow", a).each(function() {
            $(this).on("init", function() {
                setTimeout(()=>{
                    $(".slideshow", a).find('img[loading="lazy"]').each(function() {
                        theme.imageLazyLoader.loadLazyImage($(this)[0])
                    })
                }
                , 5e3)
            }).slick({
                autoplay: $(this).data("autoplay"),
                fade: "slide" != $(this).data("transition"),
                speed: b,
                autoplaySpeed: 1e3 * $(this).data("autoplay-speed"),
                arrows: "arrows" == $(this).data("navigation") || "both" == $(this).data("navigation"),
                dots: "dots" == $(this).data("navigation") || "both" == $(this).data("navigation"),
                infinite: !0,
                useTransform: !0,
                prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                pauseOnHover: !1,
                cssEase: "cubic-bezier(0.25, 1, 0.5, 1)",
                lazyLoad: $(this).find("[data-lazy]").length > 0 ? "ondemand" : null,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        fade: "slide" != $(this).data("transition"),
                        speed: "instant" == $(this).data("transition") ? 0 : 750,
                        arrows: !1,
                        dots: "none" != $(this).data("navigation"),
                        lazyLoad: $(this).find("[data-lazy]").length > 0 ? "progressive" : null
                    }
                }]
            }).on("beforeChange", function(g, e, a, b) {
                var c = "left";
                (b < a && (a !== d || 0 !== b) || 0 == a && b === d) && (1 !== b || 0 !== a) && (c = "right"),
                $(this).addClass("direction-".concat(c));
                var f = $(e.$slides.get(a));
                f.addClass("-outgoing").addClass("-leaving"),
                setTimeout(()=>{
                    $(this).removeClass("direction-left").removeClass("direction-right"),
                    f.removeClass("-outgoing")
                }
                , a === d && b == b || 0 === a && b === d ? 600 : 100),
                setTimeout(()=>{
                    f.removeClass("-leaving")
                }
                , 1e3)
            }).on("afterChange", function(b, d, a) {
                c && c(a)
            })
        })
    }
    ,
    theme.uncontainImages = function(a) {
        if ($(".reading-column [data-fullwidth]:not(.uncontain)", a).addClass("uncontain"),
        $(".reading-column .uncontain").length > 0) {
            function b() {
                var a = "rgb(255, 0, 1)" == $("#page-wrap-inner").css("border-color") ? $(window).width() : $(".container:visible:first").width();
                $(".reading-column .uncontain").each(function() {
                    var b = $(this).closest("div:not(.uncontain), p:not(.uncontain)").width();
                    $(this).css({
                        width: a,
                        marginLeft: -(a - b) / 2,
                        maxWidth: "none"
                    })
                })
            }
            $(window).on("resize.wideimgs wideimgs.wideimgs", b).trigger("wideimgs"),
            $(function() {
                b()
            })
        } else
            $(window).off(".wideimgs")
    }
    ,
    theme.formatMoney = function(c) {
        var b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : theme.money_format_with_code_preference
          , a = theme.Shopify.formatMoney(c, b);
        return theme.settings.superscriptDecimals && (b.includes("{{amount}}") || b.includes("{{ amount }}") || b.includes("{{amount_with_apostrophe_separator}}") || b.includes("{{ amount_with_apostrophe_separator }}") ? (a = a.replace(".", "<sup>"),
        theme.settings.currencyCodeEnabled && (a = a.replace(" ", "</sup> ")),
        a += "</sup>") : (b.includes("{{amount_with_comma_separator}}") || b.includes("{{ amount_with_comma_separator }}")) && (a = a.replace(",", "<sup>"),
        theme.settings.currencyCodeEnabled && (a = a.replace(" ", "</sup> ")),
        a += "</sup>")),
        a
    }
    ,
    theme.utils = {
        getUrlParameter: function(a) {
            a = a.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var b = new RegExp("[\\?&]" + a + "=([^&#]*)").exec(location.search);
            return null === b ? "" : decodeURIComponent(b[1].replace(/\+/g, " "))
        },
        cookie: {
            create: function(d, e, b) {
                var c = "";
                if (b) {
                    var a = new Date;
                    a.setTime(a.getTime() + 864e5 * b),
                    c = "; expires=" + a.toUTCString()
                }
                document.cookie = d + "=" + e + c + "; path=/"
            },
            read: function(e) {
                var c = e + "=";
                try {
                    for (var d = document.cookie.split(";"), b = 0; b < d.length; b++) {
                        for (var a = d[b]; " " == a.charAt(0); )
                            a = a.substring(1, a.length);
                        if (0 == a.indexOf(c))
                            return a.substring(c.length, a.length)
                    }
                } catch (f) {}
                return null
            },
            erase: function(a) {
                theme.utils.cookie.create(a, "", -1)
            },
            exists: function(a) {
                return void 0 !== theme.utils.cookie.read(a)
            }
        }
    };
    
    // Initialize theme.strings if it doesn't exist
    if (!theme.strings) {
        theme.strings = {
            priceNonExistent: "Price unavailable",
            buttonDefault: "Add to Cart",
            buttonNoStock: "Sold Out",
            buttonNoVariant: "Select an option",
            unitPriceSeparator: "per",
            onlyXLeft: "Only [X] left"
        };
    }
    
    theme.OptionManager = new function() {
        var _ = this;
        _._getVariantOptionElement = function(a, b) {
            return b.find('select[name="id"] option[value="' + a.id + '"]')
        }
        ,
        _.selectors = {
            container: ".product-container",
            gallery: ".product-gallery",
            priceArea: ".product-price",
            submitButton: ".product-form input[type=submit], .product-form button[type=submit]",
            multiOption: ".option-selectors"
        },
        _.strings = {
            priceNonExistent: (theme.strings && theme.strings.priceNonExistent) || "Price unavailable",
            buttonDefault: (theme.strings && theme.strings.buttonDefault) || "Add to Cart",
            buttonNoStock: (theme.strings && theme.strings.buttonNoStock) || "Sold Out",
            buttonNoVariant: (theme.strings && theme.strings.buttonNoVariant) || "Select an option",
            unitPriceSeparator: (theme.strings && theme.strings.unitPriceSeparator) || "per",
            inventoryNotice: (theme.strings && theme.strings.onlyXLeft) || "Only [X] left"
        },
        _._getString = function(c, b) {
            var a = _.strings[c];
            return b && (a = a.replace("[PRICE]", '<span class="theme-money">' + theme.formatMoney(b.price) + "</span>")),
            a
        }
        ,
        _.getProductData = function(b) {
            var a = b.data("product-id")
              , c = null;
            if (!theme.productData[a]) {
                var d = document.getElementById("ccProductJson-" + a);
                d && (theme.productData[a] = JSON.parse(d.innerHTML))
            }
            return (c = theme.productData[a]) || console.warn("CC: Product data missing (id: " + b.data("product-id") + ")"),
            c
        }
        ,
        _.getBaseUnit = function(a) {
            return 1 === a.unit_price_measurement.reference_value ? a.unit_price_measurement.reference_unit : a.unit_price_measurement.reference_value + a.unit_price_measurement.reference_unit
        }
        ,
        _.addVariantUrlToHistory = function(a) {
            if (a) {
                var b = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + a.id;
                window.history.replaceState({
                    path: b
                }, "", b)
            }
        }
        ,
        _.updateWeight = function(c, a) {
            var b = _._getVariantOptionElement(c, a).data("weight");
            b ? a.find(".product-weight").removeClass("product-weight--no-weight").find(".product-weight__value").html(b) : a.find(".product-weight").addClass("product-weight--no-weight").find(".product-weight__value").empty()
        }
        ,
        _.updateSku = function(a, b) {
            b.find(".sku .sku__value").html(a ? a.sku : ""),
            b.find(".sku").toggleClass("sku--no-sku", !a || !a.sku)
        }
        ,
        _.updateBarcode = function(a, b) {
            b.find(".barcode .barcode__value").html(a ? a.barcode : ""),
            b.find(".barcode").toggleClass("barcode--no-barcode", !a || !a.barcode)
        }
        ,
        _.updateInventoryNotice = function(c, a) {
            var b = _._getVariantOptionElement(c, a).data("inventory");
            b ? a.find(".product-inventory-notice").removeClass("product-inventory-notice--no-inventory").html(_._getString("inventoryNotice").replace("[[ quantity ]]", b)) : a.find(".product-inventory-notice").addClass("product-inventory-notice--no-inventory").empty()
        }
        ,
        _.updateInventoryLimit = function(c, a) {
            var b = _._getVariantOptionElement(c, a).data("inventory");
            b ? a.find("[data-limit]").attr("data-limit", b) : a.find("[data-limit]").attr("data-limit", "")
        }
        ,
        _.updateBackorder = function(a, c) {
            var b = c.find(".backorder");
            if (b.length) {
                if (a && a.available) {
                    if (a.inventory_management && "out" == _._getVariantOptionElement(a, c).data("stock")) {
                        var d = _.getProductData(b.closest("form"));
                        b.find(".backorder__variant").html(d.title + (a.title.indexOf("Default") >= 0 ? "" : " - " + a.title)),
                        b.removeClass("hidden")
                    } else
                        b.addClass("hidden")
                } else
                    b.addClass("hidden")
            }
        }
        ,
        _.updatePrice = function(a, e) {
            var c = e.find(_.selectors.priceArea);
            if (c.removeClass("on-sale"),
            a) {
                var b = $("<div>");
                if ($('<span class="current-price theme-money">').html(theme.formatMoney(a.price)).appendTo(b),
                a.compare_at_price > a.price && (b.append(" "),
                $('<span class="was-price theme-money">').html(theme.formatMoney(a.compare_at_price)).appendTo(b),
                c.addClass("on-sale")),
                a.unit_price_measurement) {
                    var d = $('<div class="unit-price">').appendTo(b);
                    $('<span class="unit-price__price theme-money">').html(theme.formatMoney(a.unit_price, theme.money_format)).appendTo(d),
                    $('<span class="unit-price__separator">').html(_._getString("unitPriceSeparator")).appendTo(d),
                    $('<span class="unit-price__unit">').html(_.getBaseUnit(a)).appendTo(d)
                }
                c.html(b.html())
            } else
                c.html(_._getString("priceNonExistent", a))
        }
        ,
        _._updateButtonText = function(a, b, c) {
            a.each(function() {
                var a;
                !1 !== (a = _._getString("button" + b, c)) && ($(this).is("input") ? $(this).val(a) : $(this).html(a))
            })
        }
        ,
        _.updateButtons = function(a, c) {
            var d = c.find(_.selectors.submitButton)
              , b = c.find(_.selectors.submitButton + " .button-text");
            a && !0 == a.available ? (d.removeAttr("disabled").attr("data-btn-type", "add-to-cart").removeClass("product-add--adding"),
            _._updateButtonText(b, "Default", a)) : (d.attr("disabled", "disabled").attr("data-btn-type", "unavailable"),
            a ? _._updateButtonText(b, "NoStock", a) : _._updateButtonText(b, "NoVariant", a))
        }
        ,
        _.updateContainerStatusClasses = function(a, b) {
            b.toggleClass("variant-status--unavailable", !a.available),
            b.toggleClass("variant-status--backorder", a.available && a.inventory_management && "out" == _._getVariantOptionElement(a, b).data("stock"))
        }
        ,
        _.initProductOptions = function(a) {
            $(a).not(".theme-init").addClass("theme-init").each(function() {
                var a = $(this);
                if (a.is("select")) {
                    var b = _.getProductData(a.closest("form"));
                    a.on("change.themeProductOptions firstrun.themeProductOptions", function(e) {
                        if (!$(this).is("input[type=radio]:not(:checked)")) {
                            var a = e.detail;
                            if (!a && !1 !== a)
                                for (var d = 0; d < b.variants.length; d++)
                                    b.variants[d].id == $(this).val() && (a = b.variants[d]);
                            var c = $(this).closest(_.selectors.container);
                            _.updatePrice(a, c),
                            _.updateButtons(a, c),
                            a && a.featured_media && c.find(_.selectors.gallery).trigger("variantImageSelected", a),
                            _.updateBarcode(a, c),
                            _.updateWeight(a, c),
                            _.updateSku(a, c),
                            _.updateInventoryNotice(a, c),
                            _.updateBackorder(a, c),
                            _.updateContainerStatusClasses(a, c),
                            _.updateInventoryLimit(a, c),
                            $(window).trigger("cc-variant-updated", {
                                variant: a,
                                product: b
                            }),
                            $(this).closest("form").data("enable-history-state") && "change" == e.type && _.addVariantUrlToHistory(a),
                            c.find(".quickbuy-container").trigger("changedsize")
                        }
                    }),
                    a.closest(_.selectors.container).find(_.selectors.multiOption).on("change.themeProductOptions", "select", function() {
                        var e = [];
                        $(this).closest(_.selectors.multiOption).find("select").each(function() {
                            e.push($(this).val())
                        });
                        for (var c = !1, f = 0; f < b.variants.length; f++) {
                            for (var g = b.variants[f], h = 0, d = 0; d < e.length; d++)
                                g.options[d] == e[d] && h++;
                            if (h == e.length) {
                                c = g;
                                break
                            }
                        }
                        c && a.val(c.id),
                        a[0].dispatchEvent(new CustomEvent("change",{
                            bubbles: !0,
                            cancelable: !1,
                            detail: c
                        }))
                    }),
                    a.trigger("firstrun")
                }
                theme.applyAjaxToProductForm(a.closest("form"))
            })
        }
        ,
        _.unloadProductOptions = function(a) {
            $(a).removeClass("theme-init").each(function() {
                $(this).trigger("unloading").off(".themeProductOptions"),
                $(this).closest(_.selectors.container).find(_.selectors.multiOption).off(".themeProductOptions"),
                theme.removeAjaxFromProductForm($(this).closest("form"))
            })
        }
    }
    ,
    theme.loadCartNoteMonitor = function(a) {
        $('.cart-form [name="note"]', a).on("change.themeLoadCartNoteMonitor", function() {
            $.post(theme.routes.cart_url + "/update.js", {
                note: $(this).val()
            }, function(a) {}, "json")
        })
    }
    ,
    theme.unloadCartNoteMonitor = function(a) {
        $('.cart-form [name="note"]', a).off("change.themeLoadCartNoteMonitor")
    }
    ,
    theme.loadProductGrid = function(a) {
        $(window).trigger("normheights"),
        theme.loadInPlaceQuantityAdjustment(a),
        theme.applyAjaxToProductForm($("form.product-form", a)),
        $(a).on("mouseenter.swatchHover", ".swatch-option[data-media-url]", function() {
            var a = $(this).closest(".product-block").find(".image__primary .rimage__image");
            a.attr("data-lazy-src", $(this).data("media-url")),
            theme.imageLazyLoader.loadLazyImage(a[0])
        })
    }
    ,
    theme.unloadProductGrid = function(a) {
        theme.unloadInPlaceQuantityAdjustment(a),
        theme.removeAjaxFromProductForm($("form.product-form", a)),
        $(a).off(".swatchHover")
    }
    ,
    theme.ProductMediaGallery = function(a) {
        var f, e = this, g = {}, h = a.find(".view-in-space"), i = !1, j = a.data("enable-zoom") && !theme.device.isTouch(), b = a.data("slideshow-mob-nav"), k = !1, l = !0;
        $(window).on("resize", function() {
            $(".thumbnails", a).width("100%").width($(".thumbnails", a).width())
        });
        var m = $(".thumbnails", a).on("init reInit setPosition", function(d) {
            var a = $(this).find(".slick-slide:last");
            if (a.length > 0) {
                var b = a.position().left + a.outerWidth(!0)
                  , c = $(this).width();
                $(this).toggleClass("slick-slider--all-visible", c > b)
            }
            setTimeout(function() {
                $(d.target).find(".slick-slide").attr({
                    tabindex: "0",
                    "aria-hidden": "false"
                })
            })
        }).slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: !1,
            speed: 400,
            prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
            responsive: [{
                breakpoint: 1500,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            }, {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }, {
                breakpoint: 767,
                settings: {
                    arrows: !1,
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }]
        })
          , n = $(".product-slideshow", a).slick({
            fade: !1,
            speed: 500,
            arrows: !0,
            dots: !1,
            infinite: !1,
            useTransform: !0,
            adaptiveHeight: !0,
            prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
            nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
            cssEase: "cubic-bezier(0.25, 1, 0.5, 1)",
            responsive: [{
                breakpoint: 767,
                settings: {
                    dots: "dots" === b,
                    arrows: "arrows" === b
                }
            }]
        }).on("beforeChange", function(g, d, h, f) {
            var b = $(d.$slides.get(f))
              , c = $('.thumbnail[data-media-id="'.concat(b.data("media-id"), '"]'), a);
            a.attr("data-full-image-width", c.data("full-image-width")),
            c.addClass("active").siblings(".active").removeClass("active"),
            !1 === k ? m.slick("slickGoTo", c.index()) : k = !1,
            a.attr("data-current-media-type", b.data("media-type")),
            e.setCurrentMedia(b, !1)
        }).on("afterChange", function(b, c, d) {
            a.trigger("refresh-zoom")
        });
        this.Image = function(b) {
            this.destroy = function() {
                a.trigger("zoom.destroy")
            }
            ,
            this.pause = function() {
                a.trigger("zoom.destroy")
            }
            ,
            a.closest(".quickbuy-form").length && $.colorbox.resize()
        }
        ,
        this.Video = function(a) {
            var b = this
              , c = {
                play: function() {},
                pause: function() {},
                destroy: function() {}
            }
              , d = a.find("video")[0];
            this.play = function() {
                c.play()
            }
            ,
            this.pause = function() {
                c.pause()
            }
            ,
            this.destroy = function() {
                c.destroy()
            }
            ,
            theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"),
            window.Shopify.loadFeatures([{
                name: "video-ui",
                version: "1.0",
                onLoad: (function() {
                    c = {
                        playerType: "html5",
                        element: d,
                        plyr: new Shopify.Plyr(d,{
                            controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
                            loop: {
                                active: a.data("enable-video-looping")
                            },
                            autoplay: $(window).width() >= 768,
                            hideControlsOnPause: !0,
                            iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                            tooltips: {
                                controls: !1,
                                seek: !0
                            }
                        }),
                        play: function() {
                            this.plyr.play()
                        },
                        pause: function() {
                            this.plyr.pause()
                        },
                        destroy: function() {
                            this.plyr.destroy()
                        }
                    },
                    g[a.data("media-id")] = b
                }
                ).bind(this)
            }])
        }
        ,
        this.ExternalVideo = function(c) {
            var f = this
              , d = {
                play: function() {},
                pause: function() {},
                destroy: function() {}
            }
              , b = c.find("iframe")[0];
            if (this.play = function() {
                d.play()
            }
            ,
            this.init = function() {}
            ,
            this.destroy = function() {
                d.destroy()
            }
            ,
            /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(b.src)) {
                var e = function() {
                    d = {
                        playerType: "youtube",
                        element: b,
                        player: new YT.Player(b,{
                            videoId: c.data("video-id"),
                            events: {
                                onReady: function() {
                                    g[c.data("media-id")] = f,
                                    theme.viewport.isSm() && f.play()
                                },
                                onStateChange: function(b) {
                                    0 === b.data && c.data("enable-video-looping") && b.target.seekTo(0),
                                    1 === b.data && a.attr("data-youtube-playing", "true")
                                }
                            }
                        }),
                        play: function() {
                            this.player.playVideo()
                        },
                        destroy: function() {
                            this.player.destroy()
                        }
                    }
                };
                // Wait for the DOM to be ready
                $(document).ready(function() {
                    // Add a click event listener to the div element with class 'thumbnail--media-external_video'
                    $('.thumbnail--media-external_video').on('click', function() {
                        // Get the video element by its class '.ytp-large-play-button-red-bg'
                        var video = $('.ytp-large-play-button-red-bg');

                        // Trigger a click event on the video element
                        video.click();

                        // Log a message to the console
                        console.log('Video clicked!');
                    });
                });

                if (window.YT && window.YT.Player)
                    e();
                else {
                    var h = window.onYouTubeIframeAPIReady;
                    window.onYouTubeIframeAPIReady = function() {
                        h(),
                        e()
                    }
                    ,
                    theme.loadScriptOnce("https://www.youtube.com/iframe_api")
                }
            } else
                /vimeo\.com/.test(b.src) && (i ? (c.data("enable-video-looping") && b.setAttribute("src", b.getAttribute("src") + "&loop=1"),
                (d = {
                    playerType: "vimeo",
                    element: b,
                    player: new Vimeo.Player(b),
                    play: function() {
                        this.player.play()
                    },
                    pause: function() {
                        this.player.pause()
                    },
                    destroy: function() {
                        this.player.destroy()
                    }
                }).player.ready().then(function() {
                    g[c.data("media-id")] = f,
                    theme.viewport.isSm() && f.play()
                })) : theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function() {
                    i = !0,
                    loadVimeoVideos()
                }))
        }
        ,
        this.Model = function(b) {
            var c = {
                play: function() {},
                pause: function() {},
                destroy: function() {}
            }
              , d = b.find("model-viewer")[0];
            this.init = function() {
                window.ShopifyXR && h.length && (h.attr("data-shopify-model3d-id", b.data("media-id")),
                window.ShopifyXR.setupXRElements())
            }
            ,
            this.play = function() {
                c.play()
            }
            ,
            this.pause = function() {
                c.pause(),
                window.ShopifyXR && h.length && (h.attr("data-shopify-model3d-id", h.data("shopify-model3d-first-id")),
                h.attr("data-shopify-title", h.data("shopify-first-title")),
                window.ShopifyXR.setupXRElements())
            }
            ,
            this.destroy = function() {}
            ,
            this.initAugmentedReality = function() {
                if ($(".model-json", a).length) {
                    var b = function b() {
                        if (!window.ShopifyXR) {
                            document.addEventListener("shopify_xr_initialized", function c(a) {
                                b(),
                                a.target.removeEventListener(a.type, c)
                            });
                            return
                        }
                        window.ShopifyXR.addModels(JSON.parse($(".model-json", a).html())),
                        window.ShopifyXR.setupXRElements()
                    };
                    window.Shopify.loadFeatures([{
                        name: "shopify-xr",
                        version: "1.0",
                        onLoad: b
                    }])
                }
            }
            ,
            theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"),
            window.Shopify.loadFeatures([{
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: (function() {
                    c = new Shopify.ModelViewerUI(d)
                }
                ).bind(this)
            }]),
            b.find("model-viewer").on("shopify_model_viewer_ui_toggle_play", function() {
                b.addClass("product-media-model--playing"),
                n.slick("slickSetOption", "swipe", !1),
                n.slick("slickSetOption", "accessibility", !1)
            }),
            b.find("model-viewer").on("shopify_model_viewer_ui_toggle_pause", function() {
                b.removeClass("product-media-model--playing"),
                n.slick("slickSetOption", "swipe", !0),
                n.slick("slickSetOption", "accessibility", !0)
            }),
            g[b.data("media-id")] = this,
            window.ShopifyXR || this.initAugmentedReality()
        }
        ,
        this.setCurrentMedia = function(a, c, d) {
            if (a.length) {
                f && "function" == typeof f.pause && f.pause();
                var b = function(c) {
                    var b;
                    return g.hasOwnProperty(a.data("media-id")) ? (b = g[a.data("media-id")],
                    $(window).width() >= 768 ? ("function" == typeof b.init && b.init(),
                    setTimeout(b.play, 250)) : "function" == typeof b.init && b.init()) : b = new c(a),
                    b
                };
                "image" === a.data("media-type") ? f = b(e.Image) : "video" === a.data("media-type") ? f = b(e.Video) : "external_video" === a.data("media-type") ? f = b(e.ExternalVideo) : "model" === a.data("media-type") ? f = b(e.Model) : console.warn("CC: Media is unknown", a),
                c && (k = !d,
                n.slick("slickGoTo", a.index(), l),
                l = !1)
            }
        }
        ,
        this.destroy = function() {
            for (var b = 0; b < g.length; b++)
                g[b].destroy();
            $(".main a.main-img-link--lightbox", a).off("click"),
            $(".thumbnails .thumbnail", a).off("click"),
            $(".thumbnails", a).slick("unslick").off("init reInit setPosition"),
            $(".product-slideshow", a).slick("unslick"),
            a.off("variantImageSelected")
        }
        ;
        var c = a.find(".product-media:first");
        if (this.setCurrentMedia(c, !1, !0),
        "model" !== c.data("media-type") && 768 > $(window).width()) {
            var d = a.find('.product-media[data-media-type="model"]:first');
            d.length && new e.Model(d,!0)
        }
        (0 === a.find(".product-media--image").length && 1 === a.find(".product-gallery--hover-veil").length || a.data("enable-zoom") && theme.device.isTouch()) && a.find(".product-gallery--hover-veil").remove(),
        a.on("click", ".main a.main-img-link--lightbox", function() {
            return $(window).height() >= 580 && $(window).width() >= 768 && (1 == a.find("img:not(.zoomImg)").length ? $.colorbox({
                href: $(this).attr("href"),
                minWidth: "200",
                maxWidth: "96%",
                maxHeight: "96%"
            }) : ($("#gallery-cont").remove(),
            $('<div id="gallery-cont"/>').append(a.find(".thumbnails a[data-media-type='image']").clone().attr({
                rel: "gallery",
                title: ""
            })).hide().appendTo("body").children().colorbox({
                className: "product-gallery--popup",
                minWidth: "200",
                maxWidth: "96%",
                maxHeight: "96%",
                next: theme.icons.right,
                previous: theme.icons.left,
                close: theme.icons.close
            }).filter('[href="' + $(this).attr("href") + '"]').first().click())),
            !1
        }),
        a.on("click", ".thumbnails .thumbnail", function(b) {
            b.preventDefault();
            var c = a.find('.product-media[data-media-id="'.concat($(this).data("media-id"), '"]'));
            e.setCurrentMedia(c, !0, !1)
        }),
        a.on("variantImageSelected", function(d, b) {
            var c = a.find('.product-media[data-media-id="'.concat(b.featured_media.id, '"]'));
            e.setCurrentMedia(c, !0, !0)
        }),
        a.on("initzoom", function() {
            if (j) {
                var c;
                function b() {
                    var b = a.find(".main .product-media.slick-active .main-img-link");
                    if (b.length && b.attr("href") !== c) {
                        a.removeClass("gallery-loaded");
                        var d = new Image;
                        d.onload = ()=>{
                            setTimeout(()=>{
                                a.addClass("gallery-loaded")
                            }
                            , 0)
                        }
                        ,
                        d.src = b.attr("href"),
                        c = b.attr("href"),
                        b.trigger("zoom.destroy").removeClass("zoom-enabled"),
                        theme.viewport.isSm() && a.width() < a.data("full-image-width") && (b.hasClass("zoom-enabled") || b.zoom({
                            url: b.attr("href")
                        }).addClass("zoom-enabled"))
                    }
                }
                b(),
                $(window).on("debouncedresize", b),
                a.on("refresh-zoom", b)
            }
        }),
        a.trigger("initzoom")
    }
    ,
    theme.initProductForm = function(a) {
        var d = theme.OptionManager.getProductData(a)
          , j = a.find(".qty-adjuster");
        theme.OptionManager.initProductOptions($('[name="id"]', a));
        var k = "," + a.find(".option-selectors").data("box-options") + ",";
        if ($(".selector-wrapper:not(.has-clickyboxes) select", a).filter(function() {
            return k.indexOf("," + $(this).closest(".selector-wrapper").find("label").html() + ",") >= 0
        }).clickyBoxes().parent().addClass("has-clickyboxes").length > 0)
            for (var b = 0; b < d.options.length; b++) {
                for (var c = {}, f = 0; f < d.variants.length; f++) {
                    var e = d.variants[f];
                    void 0 === c[e.options[b]] && (c[e.options[b]] = !1),
                    e.available && (c[e.options[b]] = !0)
                }
                for (var g in c)
                    c[g] || $(".selector-wrapper:eq(" + b + ") .clickyboxes li a", a).filter(function() {
                        return $(this).attr("data-value") == g
                    }).addClass("unavailable")
            }
        function h() {
            var f, d = a.find('select[name="id"]').val(), b = JSON.parse($("#LimitedCartJson").html()), e = !1;
            if (b && b.items && d && (e = b.items.some(a=>{
                if (a.id == d)
                    return f = a,
                    !0
            }
            )),
            j.attr("data-line-item-id", d),
            e) {
                var c = a.find(".product-add");
                c.removeClass("product-add--adding"),
                c.attr("data-btn-type", "in-cart"),
                c.find(".button-text").text(theme.strings.removeFromCart),
                theme.loadInPlaceQuantityAdjustment(a.parent(), b),
                theme.applyAjaxToProductForm(a.parent()),
                a.find(".qty-adjuster__value").val(f.quantity),
                theme.updateAdjusterButtonsDisabledState(j, !1, !0)
            } else
                a.removeClass("product-form--added"),
                theme.updateAdjusterButtonsDisabledState(j, !0),
                a.find(".qty-adjuster--loading").removeClass("qty-adjuster--loading")
        }
        a.find('select:not([name="id"])').selectReplace().closest(".selector-wrapper").addClass("has-pretty-select"),
        a.closest(".quickbuy-form").length && a.find('[name="id"]').on("change", function() {
            setTimeout(function() {
                $.colorbox.resize()
            }, 10)
        });
        var i = a.hasClass("product-form--not-quickbuy");
        i && (h(),
        $(window).on("cc-cart-updated", ()=>{
            $('[name="id"]', a).trigger("change")
        }
        )),
        $(window).on("cc-variant-updated.ajax-buttons".concat(d.id), (f,b)=>{
            if (b.product.id === d.id) {
                b.variant.available && i ? h() : theme.updateAdjusterButtonsDisabledState(j, !0);
                var c = a.find(".variant-swatch-value");
                c.length && c.html(": ".concat(c.closest(".selector-wrapper").find(".active").data("value")));
                var e = a.find("#sample-it");
                e.length && e.data("variant", b.variant.id)
            }
        }
        )
    }
    ,
    theme.unloadProductForm = function(a) {
        theme.OptionManager.unloadProductOptions($('[name="id"]', a)),
        a.find('[name="id"]').off("change"),
        a.find(".clickybox-replaced").clickyBoxes("destroy"),
        $("select.replaced", a).selectReplace("destroy"),
        a.find(".qty-adjuster").off("click");
        var b = theme.OptionManager.getProductData(a);
        b && $(window).off("cc-variant-updated.ajax-buttons".concat(b.id))
    }
    ,
    theme.applyAjaxToProductForm = function(a) {
        var b = theme.routes.cart_add_url + ".js";
        theme.routes.cart_url,
        a.filter('[data-ajax-add-to-cart="true"]').on("submit", function(f) {
            f.preventDefault();
            var a = $(this)
              , d = 1
              , e = a.find(".qty-adjuster__value");
            e.length && (d = e.val()),
            a.find(":submit").attr("disabled", "disabled").each(function() {
                $(this).addClass("product-add--adding")
            });
            var g = a.find(":submit");
            theme.cartLoadingStarted();
            var c = a.serialize();
            -1 === c.indexOf("quantity=") && (c += "&quantity=".concat(d)),
            $.post(b, c, function(b) {
                Shopify.getCart((function(b) {
                    theme.utils.cookie.create("theme_added_to_cart", "justnow", 1),
                    g.each(function() {
                        var a = $(this);
                        setTimeout(()=>{
                            a.addClass("product-add--added").removeAttr("disabled"),
                            setTimeout(()=>{
                                a.removeClass("product-add--added").removeClass("product-add--adding")
                            }
                            , 2e3)
                        }
                        , 500)
                    }).first(),
                    theme.updateCartSummaries(a.data("open-cart-drawer") || theme.settings.openCartDrawerOnMob && 1100 > $(window).outerWidth(), !0, !a.hasClass("product-form--not-quickbuy"))
                }
                ).bind(this))
            }, "json").fail(function(b) {
                var c = a.find(":submit").removeAttr("disabled").each(function() {
                    var a = $(this)
                      , b = a.is("button") ? "html" : "val";
                    a[b](a.data("previous-value"))
                }).first();
                if (void 0 !== b && void 0 !== b.status) {
                    var d = $.parseJSON(b.responseText);
                    theme.showQuickPopup(d.description, e && e.length ? e : c)
                } else
                    a.attr("ajax-add-to-cart", "false").submit();
                g.each(function() {
                    $(this).removeClass("product-add--adding")
                })
            }).always(function() {
                theme.cartLoadingFinished()
            })
        })
    }
    ,
    theme.removeAjaxFromProductForm = function(a) {
        a.off("submit")
    }
    ,
    theme.updateAdjusterButtonsDisabledState = function(a, e, f) {
        var c = a.find(".qty-adjuster__value")
          , b = a.attr("data-limit");
        b && (b = parseInt(b)),
        e && c.val("1");
        var d = parseInt(c.val());
        a.closest(".variant-status--unavailable").length ? a.find(".qty-adjuster__up,.qty-adjuster__down").attr("disabled", "disabled") : (d === b ? a.find(".qty-adjuster__up").attr("disabled", "disabled") : a.find(".qty-adjuster__up").removeAttr("disabled"),
        d > 1 ? a.find(".qty-adjuster__down").removeAttr("disabled") : f ? a.find(".qty-adjuster__down").removeAttr("disabled") : a.find(".qty-adjuster__down").attr("disabled", "disabled")),
        c.removeAttr("disabled")
    }
    ,
    theme.disableInPlaceQuantityAdjustment = function(a) {
        a.addClass("qty-adjuster--loading")
    }
    ,
    theme.enableInPlaceQuantityAdjustment = function(a) {
        a.removeClass("qty-adjuster--loading")
    }
    ,
    theme.loadInPlaceQuantityAdjustment = function(c, a) {
        if ($(".qty-adjuster:first", c).length && theme.settings.cartType.includes("drawer")) {
            function b(g) {
                $(".product-form--mini", c).addClass("product-form--temp-could-remove");
                for (var e = 0; e < g.items.length; e++) {
                    var d = g.items[e]
                      , a = null
                      , b = $('.product-form--mini[data-product-id="' + d.product_id + '"]', c);
                    if (b) {
                        var f = b.find(".product-add");
                        f.length && f.css("height", f.outerHeight() + "px"),
                        b.addClass("product-form--added").removeClass("product-form--temp-could-remove"),
                        a = b.parent().find(".qty-adjuster"),
                        b.hasClass("product-form--not-quickbuy") || a.attr("data-line-item-id", d.id)
                    }
                    a || (a = $('.qty-adjuster[data-line-item-id="' + d.id + '"]', c)),
                    a && (a.removeClass("qty-adjuster--loading"),
                    b.hasClass("product-form--not-quickbuy") || a.find(".qty-adjuster__value").val(d.quantity),
                    a.find(".qty-adjuster__value").removeAttr("disabled"),
                    theme.updateAdjusterButtonsDisabledState(a, !1, !0))
                }
                $(".product-form--temp-could-remove", c).removeClass("product-form--added product-form--temp-could-remove")
            }
            a ? b(a) : $.getJSON(theme.routes.cart_url + ".js", b)
        }
    }
    ,
    theme.unloadInPlaceQuantityAdjustment = function(a) {}
    ,
    theme.cartUpdatingRemoveTimeout = -1,
    theme.cartLoadingStarted = function() {
        $("body").addClass("updating-cart")
    }
    ,
    theme.cartLoadingFinished = function() {
        clearTimeout(theme.cartUpdatingRemoveTimeout),
        setTimeout(function() {
            $("body").removeClass("updating-cart")
        }, 500)
    }
    ,
    theme.updateCartSummaries = function(a, b, c) {
        theme.cartLoadingStarted();
        var d = $(".cart-summary__item-list:first").scrollTop()
          , e = $(".cart-summary__inner:first").scrollTop();
        $.get(theme.routes.search_url, function(o) {
            for (var i, l = [".toolbar-cart .current-cart", ".cart-summary"], p = $($.parseHTML("<div>" + o + "</div>")).wrap("<div>").parent(), j = 0; j < l.length; j++) {
                var m = l[j]
                  , g = p.find(m).clone();
                g.find(".fade-in").removeClass("fade-in");
                var h = $(m)
                  , k = g.find(".cart-summary__buttons");
                k.length && k.css("height", h.find(".cart-summary__buttons").outerHeight() + "px");
                var f = g.find(".cart-summary-item-container").eq(0);
                h.find('.cart-summary-item-container[data-product-id="'.concat(f.data("product-id"), '"]')).length && (b = !1),
                b && f.length && f.addClass("cart-summary-item-container--out-left").hide();
                var q = $(".cart-form--checkout", h)
                  , n = $(".cart-form--non-stick", h);
                q.hasClass("cart-form--checkout--sticky-true") && n.length && g.find(".cart-form--checkout").css("top", -Math.abs(parseInt(n.outerHeight() + 1)) + "px"),
                h.replaceWith(g),
                b && f.length && (f.slideDown(300),
                f.removeClass("cart-summary-item-container--out-left")),
                k.length && setTimeout(function() {
                    $(m).find(".cart-summary__buttons").css("height", "auto")
                }, 1e3)
            }
            $("#LimitedCartJson").length && (i = JSON.parse($("#LimitedCartJson").html()),
            c ? setTimeout(()=>{
                theme.loadInPlaceQuantityAdjustment($("body"), i)
            }
            , 800) : theme.loadInPlaceQuantityAdjustment($("body"), i),
            theme.applyAjaxToProductForm($(".cart-summary form.product-form"))),
            theme.loadCartNoteMonitor($(".cart-summary")),
            $(".cart-summary__item-list:first").scrollTop(d),
            $(".cart-summary__inner:first").scrollTop(e),
            "page" != theme.settings.cartType && (a && setTimeout(function() {
                $("body").addClass("show-cart-summary product-added-to-cart"),
                setTimeout(function() {
                    $(".cart-summary__close").focus()
                }, 200)
            }, 20),
            $(".cart-summary.updating, .cart-summary .updating").removeClass("updating"),
            i && $(window).trigger("cc-cart-updated", {
                cartItemData: i
            }))
        }).always(function() {
            theme.cartLoadingFinished()
        })
    }
    ,
    theme.carousels = {
        init: ()=>{
            var a = this;
            a.updateArrows = a=>{
                var b = $(a).closest(".section")[0];
                a.scrollLeft < 15 ? b.classList.add("cc-start") : b.classList.remove("cc-start"),
                a.scrollLeft + a.clientWidth > a.scrollWidth - 15 ? b.classList.add("cc-end") : (b.classList.remove("cc-end"),
                b.classList.add("cc-carousel-scrolling"))
            }
            ,
            a.initArrows = ()=>{
                document.querySelectorAll(".cc-carousel").forEach(d=>{
                    var e = $(d).closest(".section")
                      , b = e.find(".cc-carousel--next")
                      , c = e.find(".cc-carousel--previous");
                    b.addClass("cc-initialized"),
                    c.addClass("cc-initialized"),
                    b.length && c.length && (b.on("click.cc-carousel", function() {
                        var b = -1
                          , c = $(this).closest(".section").find(".cc-carousel").offset().left;
                        $(d).find(".column").each(function() {
                            var a = parseInt($(this).offset().left - c);
                            a > d.scrollLeft + d.clientWidth - 20 && -1 === b && (b = a)
                        }),
                        -1 === b && (b = d.scrollLeft + d.clientWidth),
                        a.scrollLeft(d, b)
                    }),
                    c.on("click.cc-carousel", function() {
                        var b = -1;
                        if (theme.viewport.isXs()) {
                            var c = $(this).closest(".section").find(".cc-carousel").offset().left
                              , e = {};
                            $(d).find(".column").each(function(a) {
                                var f = parseInt($(this).offset().left - c);
                                f >= 0 && -1 === b && (b = $(this).hasClass("min-cols-2") && e[a - 2] ? d.scrollLeft + e[a - 2] : d.scrollLeft + e[a - 1]),
                                e[a] = f
                            })
                        }
                        -1 === b && (b = d.scrollLeft - d.clientWidth),
                        a.scrollLeft(d, b)
                    })),
                    a.updateArrows(d)
                }
                )
            }
            ,
            a.scrollLeft = (b,c)=>{
                b.classList.add("cc-carousel--smooth-scroll"),
                b.scrollLeft = c,
                setTimeout(()=>{
                    a.updateArrows(b),
                    b.classList.remove("cc-carousel--smooth-scroll")
                }
                , scrollSpeed)
            }
            ,
            a.initMobileCarousels = ()=>{
                theme.viewport.isXs() ? document.querySelectorAll(".cc-carousel-mobile:not(.cc-carousel)").forEach(b=>{
                    b.classList.add("cc-carousel");
                    var a = $(b).closest(".section");
                    a.find(".cc-carousel--next").addClass("cc-initialized"),
                    a.find(".cc-carousel--previous").addClass("cc-initialized"),
                    a.addClass("cc-is-carousel")
                }
                ) : document.querySelectorAll(".cc-carousel-mobile.cc-carousel").forEach(b=>{
                    b.classList.remove("cc-carousel");
                    var a = $(b).closest(".section");
                    a.find(".cc-carousel--next").removeClass("cc-initialized"),
                    a.find(".cc-carousel--previous").removeClass("cc-initialized"),
                    a.removeClass("cc-is-carousel")
                }
                )
            }
            ,
            a.initCarousels = ()=>{
                var b = document.querySelectorAll(".cc-carousel");
                b.length && (theme.viewport.isSm() && !theme.browser.isSafari() ? b.forEach(b=>{
                    var c, d, e = !1;
                    b.classList.contains("cc-initialized") || (b.classList.add("cc-initialized"),
                    b.addEventListener("mousedown", a=>{
                        e = !0,
                        c = a.pageX - b.offsetLeft,
                        d = b.scrollLeft
                    }
                    ),
                    b.addEventListener("mouseleave", ()=>{
                        e = !1
                    }
                    ),
                    b.addEventListener("mouseup", ()=>{
                        e = !1,
                        a.updateArrows(b)
                    }
                    ),
                    b.addEventListener("mousemove", f=>{
                        if (e) {
                            f.preventDefault();
                            var g = f.pageX - b.offsetLeft - c;
                            b.scrollLeft = d - g,
                            a.updateArrows(b)
                        }
                    }
                    ))
                }
                ) : b.forEach(b=>{
                    var c;
                    b.addEventListener("touchend", ()=>{
                        a.updateArrows(b)
                    }
                    ),
                    b.addEventListener("scroll", ()=>{
                        clearTimeout(c),
                        c = setTimeout(()=>{
                            a.updateArrows(b)
                        }
                        , 300)
                    }
                    , {
                        passive: !0
                    })
                }
                ),
                a.initArrows())
            }
            ,
            document.querySelectorAll(".cc-carousel-mobile").length && ($(window).off("debouncedresizewidth.cc-carousel").on("debouncedresizewidth.cc-carousel", a.initMobileCarousels),
            a.initMobileCarousels()),
            a.initCarousels()
        }
        ,
        destroy() {
            var a = document.querySelector(".cc-carousel");
            a && a.length && a.forEach(a=>{
                a.removeEventListener("mousedown").removeEventListener("mouseleave").removeEventListener("mouseup").removeEventListener("mousemove").classList.remove("cc-initialized");
                var b = $(a).closest(".section");
                b.find(".cc-carousel--previous").removeClass("cc-initialized"),
                b.find(".cc-carousel--next").removeClass("cc-initialized")
            }
            ),
            $(window).off(".cc-carousel")
        }
    },
    $(function($) {
        var a = null;
        $(document).on("click", ".quick-buy", function(i) {
            if (a)
                return !1;
            var c, j = $(this), k = $('.quickbuy-placeholder-template[data-product-id="' + j.data("product-id") + '"]:first').html(), l = $('<div class="quickbuy-container">' + k + "</div>"), d = null, e = null, g = $(this).closest(".product-block"), m = g.parent(), f = m.children(".product-block".concat("hover" === theme.settings.quickBuyType ? ":not('.page-block'):not(.product-block--flex-spacer)" : ".product-block--with-quickbuy"));
            if (g.length && (f.each(function(a) {
                $(this).attr("id") === g.attr("id") && (c = a)
            }),
            null != c)) {
                c > 0 && (d = f.eq(c - 1).attr("id"));
                var h = f.eq(c + 1);
                h && (e = h.attr("id"))
            }
            return $.colorbox({
                closeButton: !1,
                preloading: !1,
                open: !0,
                speed: 200,
                html: ['<div class="action-icons">', null != d ? '<a href="#" class="prev-item action-icon" data-idx="' + d + '" aria-label="' + theme.strings.previous + '">' + theme.icons.left + "</span></a>" : "", null != e ? '<a href="#" class="next-item action-icon" data-idx="' + e + '" aria-label="' + theme.strings.next + '">' + theme.icons.right + "</a>" : "", '<a href="#" class="close-box action-icon" aria-label="', theme.strings.close, '">' + theme.icons.close + "</a>", "</div>", l.wrap("<div>").parent().html()].join(""),
                onComplete: function() {
                    b(j.attr("href"))
                },
                onCleanup: function() {
                    theme.activeQuickBuyMediaGallery && theme.activeQuickBuyMediaGallery.destroy(),
                    theme.unloadProductForm($(".quickbuy-container .product-form"))
                }
            }),
            i.stopImmediatePropagation(),
            !1
        });
        var b = function(b) {
            a = $.get(b, function(g) {
                var c = $("<div>").append($(g).find('.section-product-template [data-section-type="product-template"]').clone());
                c.find("[data-cc-animate]").removeAttr("data-cc-animate"),
                c.find(".product-collection-links").remove(),
                c.find(".store-availability-container-outer").remove(),
                c.find(".social-links").remove(),
                c.find("[data-enable-history-state]").attr("data-enable-history-state", "false"),
                c.find(".theme-product-reviews-full").remove(),
                c.find(".product-mob-collection-links").remove(),
                c.find('[data-show-in-quickbuy="false"]').remove(),
                c.find(".product-description-below").remove(),
                c.find(".product-section.border-bottom").removeClass("border-bottom"),
                c.find(".product-container").addClass("product-container--quickbuy"),
                c.find(".product-details").append('<div class="more-link-row"><a class="more-link" href="'.concat(b, '">').concat(theme.strings.fullDetails, "</a></div>"));
                var d = $('<div class="quickbuy-form quickbuy-form--overlay">' + c.html() + "</div>");
                d.find("label[for]").each(function() {
                    $(this).attr("for", $(this).attr("for") + "-qb")
                }),
                d.find(":input[id]").each(function() {
                    $(this).attr("id", $(this).attr("id") + "-qb")
                });
                var e = $(".quickbuy-container");
                e.html(d),
                $("body").removeClass("product-added-to-cart");
                var f = e.find(".product-container .product-gallery");
                1 === f.length && (theme.activeQuickBuyMediaGallery = new theme.ProductMediaGallery(f)),
                theme.initProductForm(e.find(".product-form")),
                $(".quickbuy-form").imagesLoaded(function() {
                    setTimeout($.colorbox.resize, 10)
                }),
                d.hide().fadeIn(300, function() {
                    $(".quickbuy-form.placeholder").remove(),
                    d.removeClass("quickbuy-form--overlay"),
                    $.colorbox.resize()
                }),
                Shopify.PaymentButton && ($(document).on("shopify:payment_button:loaded.themeQuickBuy", function() {
                    $(document).off("shopify:payment_button:loaded.themeQuickBuy"),
                    $.colorbox.resize()
                }),
                Shopify.PaymentButton.init()),
                theme.initAnimateOnScroll(),
                $(document).trigger("cc:component:load", ["accordion", $(".quickbuy-container")[0]]),
                a = null
            })
        }
    });
    class o {
        constructor(a) {
            if (!a) {
                console.warn("No container provided to StickyScrollDirection component");
                return
            }
            this.container = a,
            this.currentTop = 0,
            this.scrollY = window.scrollY,
            this.updateDefaultTop(),
            theme.viewport.isSm() && this.bindEvents()
        }
        bindEvents() {
            this.scrollListener = this.handleScroll.bind(this),
            this.updateTopListener = theme.debounce(this.updateDefaultTop.bind(this)),
            window.addEventListener("scroll", this.scrollListener),
            window.addEventListener("cc-header-updated", this.updateTopListener),
            window.addEventListener("resize", this.updateTopListener)
        }
        updateDefaultTop() {
            var a = $(".product-list-toolbar");
            a ? this.defaultTop = a.outerHeight() + 20 : this.defaultTop = 0
        }
        handleScroll() {
            var a = this.container.getBoundingClientRect().top + window.scrollY - this.container.offsetTop + this.defaultTop
              , b = this.container.clientHeight - window.innerHeight;
            window.scrollY < this.scrollY ? this.currentTop -= window.scrollY - this.scrollY : this.currentTop += this.scrollY - window.scrollY,
            this.currentTop = Math.min(Math.max(this.currentTop, -b), a, this.defaultTop),
            this.scrollY = window.scrollY,
            this.container.style.top = this.currentTop + "px"
        }
        destroy() {
            window.removeEventListener("scroll", this.scrollListener),
            window.removeEventListener("cc-header-updated", this.updateTopListener),
            window.removeEventListener("resize", this.updateTopListener)
        }
    }
    new class extends j {
        constructor() {
            var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "sticky-scroll-direction"
              , b = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(a, ":not(.cc-initialized)");
            super(a, b)
        }
        init(a) {
            super.init(a),
            this.registerInstance(a, new o(a))
        }
        destroy(a) {
            this.destroyInstance(a),
            super.destroy(a)
        }
    }
    ,
    theme.FooterSection = new function() {
        this.onSectionLoad = function(a) {
            $(".disclosure", a).each(function() {
                $(this).data("disclosure", new theme.Disclosure($(this)))
            })
        }
        ,
        this.onSectionUnload = function(a) {
            $(".disclosure", a).each(function() {
                $(this).data("disclosure").unload()
            })
        }
    }
    ,
    theme.CartDrawerSection = new function() {
        this.onSectionLoad = function(a) {
            theme.applyAjaxToProductForm($("form.product-form", a)),
            theme.loadCartNoteMonitor(a);
            var d = $("body")
              , e = $(window);
            function b() {
                0 === e.scrollTop() ? d.addClass("scrolled-top") : d.removeClass("scrolled-top")
            }
            function c() {
                var b = $(".cart-form--checkout", a)
                  , c = $(".cart-form--non-stick", a);
                b.hasClass("cart-form--checkout--sticky-true") && c.length && b.css("top", -Math.abs(parseInt(c.outerHeight() + 1)) + "px")
            }
            b(),
            theme.viewport.isSm() && $(window).on("throttled-scroll.cartDrawer", b),
            $(a).on("click", ".btn--empty-cart", function() {
                return confirm(theme.strings.confirmEmptyCart) && ($(a).find(".cart-summary-item-container").each(function(a) {
                    setTimeout(()=>{
                        $(this).addClass("cart-summary-item-container--out")
                    }
                    , 50 * a)
                }),
                $.post(theme.routes.cart_clear_url, function() {
                    theme.updateCartSummaries(!1, !1)
                })),
                !1
            }),
            $(a).on("click", ".cart-accordion-btn", function(a) {
                a.preventDefault(),
                a.stopImmediatePropagation();
                var b = $(this).parent().next().toggleClass("hidden").hasClass("hidden");
                $(this).toggleClass("cart-accordion-btn--collapsed", b),
                b || $(this).closest(".cart-summary").find(".cart-accordion-btn:not(.cart-accordion-btn--collapsed)").not(this).click()
            }),
            $(a).on("click", ".cart-accordion-btn-container", function(a) {
                a.preventDefault(),
                $(this).find(".cart-accordion-btn").click()
            }),
            c(),
            $(window).on("debouncedresize.cartDrawer cc-cart-updated", c)
        }
        ,
        this.onSectionUnload = function(a) {
            theme.removeAjaxFromProductForm($("form.product-form", a)),
            theme.unloadCartNoteMonitor(a),
            $(window).off(".cartDrawer")
        }
        ,
        this.onSectionSelect = function(a) {
            $("body").hasClass("show-cart-summary") || $(".toggle-cart-summary:first").click()
        }
        ,
        this.onSectionDeselect = function(a) {
            $("body").hasClass("show-cart-summary") && $(".toggle-cart-summary:first").click()
        }
    }
    ,
    theme.SlideshowSection = new function() {
        this.onSectionLoad = function(a) {
            theme.initContentSlider(a),
            $(a).find(".image-overlay--mobile-stack").length > 0 ? $(a).parent().addClass("slideshow-section--mobile-stack") : $(a).parent().addClass("slideshow-section--no-mobile-stack")
        }
        ,
        this.onSectionUnload = function(a) {
            $(".slick-slider", a).slick("unslick").off("init"),
            $(window).off(".slideshowSection")
        }
        ,
        this.onBlockSelect = function(a) {
            $(a).closest(".slick-slider").slick("slickGoTo", $(a).data("slick-index")).slick("slickPause")
        }
        ,
        this.onBlockDeselect = function(a) {
            $(a).closest(".slick-slider").slick("slickPlay")
        }
    }
    ,
    theme.ProductTemplateSection = new function() {
        var a = [];
        this.onSectionLoad = function(b) {
            $("[data-store-availability-container]", b).length && (this.storeAvailability = new theme.StoreAvailability($("[data-store-availability-container]", b)[0])),
            $(".product-gallery", b).each(function() {
                a.push(new theme.ProductMediaGallery($(this)))
            }),
            $(".product-form:not(.product-form--placeholder)", b).length && theme.initProductForm($(".product-form", b)),
            $(".cc-rating-container", b).length && ($("#shopify-product-reviews").length ? $(b).on("click", ".cc-rating-container", function() {
                return theme.viewport.scrollTo($("#shopify-product-reviews"), -1, 500, 100, 1 === $('.header-container[data-is-sticky="true"]').length),
                !1
            }) : $(".cc-rating-container", b).css("cursor", "default")),
            $(b).on("click", ".size-chart-link", function() {
                $.colorbox({
                    inline: !0,
                    href: "#size-chart-content > .size-chart"
                })
            }),
            $(window).trigger("normheights")
        }
        ,
        this.onSectionUnload = function(b) {
            if ($(b).off("click"),
            $(".product-gallery .thumbnails", b).slick("unslick"),
            a.length)
                for (var c = 0; c < a.length; c++)
                    a[c].destroy();
            theme.unloadProductForm($(".product-form", b)),
            this.storeAvailability && this.storeAvailability.onSectionUnload(),
            $(".product-slideshow", b).slick("unslick").off("init")
        }
    }
    ,
    theme.FilterManager = new function() {
        this.onSectionLoad = function(a) {
            this.namespace = theme.namespaceFromSection(a),
            this.$container = $(a),
            this.$productFilter = $(".cc-product-filter", this.$container),
            this.filters_closed_cookie_name = "theme_filters_closed",
            this.$container.data("ajax-filtering") ? (this.$container.on("click" + this.namespace, ".pagination a,.active-filter-controls a", this.functions.ajaxLoadLink.bind(this)),
            this.$container.on("change" + this.namespace + " submit" + this.namespace, "[data-filter-form]", theme.debounce(this.functions.ajaxLoadForm.bind(this), 700)),
            this.registerEventListener(window, "popstate", this.functions.ajaxPopState.bind(this))) : this.$container.on("change" + this.namespace, "[data-filter-form]", this.functions.submitForm),
            this.$container.on("click" + this.namespace, ".cc-toolbar-filter-toggle", this.functions.toggleFilter.bind(this)),
            this.$container.on("click" + this.namespace, ".cc-product-filter__mob-veil, .cc-product-filter__close", this.functions.handleMobileVeilTap.bind(this)),
            this.$container.on("submit" + this.namespace, "#search-page-form", this.functions.updateSearchQuery.bind(this)),
            theme.viewport.isSm() && theme.utils.cookie.exists(this.filters_closed_cookie_name) && "true" == theme.utils.cookie.read(this.filters_closed_cookie_name) && $(a).addClass("cc-filters-closed").addClass("cc-filters-closed-no-trans"),
            $("select:not([name=id])", a).selectReplace(),
            this.$container.data("use-infinite-scroll") ? (theme.loadProductGrid(this.$container),
            this.functions.initInfiniteScroll()) : theme.loadProductGrid(a)
        }
        ,
        this.functions = {
            initInfiniteScroll: function() {
                $(".product-list.use-infinite-scroll", this.$container).each(function() {
                    var a = $(this);
                    theme.loadScriptOnce(theme.scripts.jqueryInfiniteScroll, function() {
                        a.infinitescroll({
                            navSelector: ".pagination",
                            nextSelector: ".pagination .next",
                            itemSelector: ".product-list .product-block",
                            loading: {
                                msgText: theme.strings.infiniteScrollCollectionLoading,
                                finishedMsg: theme.strings.infiniteScrollCollectionFinishedMsg
                            },
                            pathParse: function(a, b) {
                                return a.match(/^(.*page=)[0-9]*(&.*)?$/).splice(1)
                            }
                        }, function(b) {
                            a.find("#infscr-loading").remove(),
                            a.find(".product-block:not(.product-block--flex-spacer):last").prevAll(".product-block--flex-spacer").remove(),
                            theme.loadProductGrid(this.$container)
                        })
                    })
                })
            },
            updateSearchQuery: function(b) {
                var a = this.$container.find("[data-filter-form]:first");
                a.length && ((b.preventDefault(),
                a.find('[name="q"]').val($(b.currentTarget).find('[name="q"]').val()),
                this.$container.data("ajax-filtering")) ? this.functions.ajaxLoadForm.bind(this)({
                    type: null,
                    currentTarget: a[0]
                }) : a.submit())
            },
            submitForm: function(a) {
                a.currentTarget.submit()
            },
            handleMobileVeilTap: function() {
                this.$container.toggleClass("cc-filters-mob-open")
            },
            toggleFilter: function() {
                return this.$container.removeClass("cc-filters-closed-no-trans"),
                theme.viewport.isXs() ? this.$container.toggleClass("cc-filters-mob-open") : this.$container.hasClass("cc-filters-closed") ? (theme.utils.cookie.create(this.filters_closed_cookie_name, "false", 365),
                this.$container.removeClass("cc-filters-closed")) : (theme.utils.cookie.create(this.filters_closed_cookie_name, "true", 365),
                this.$container.addClass("cc-filters-closed")),
                !1
            },
            ajaxLoadLink: function(a) {
                a.preventDefault(),
                this.functions.ajaxLoadUrl.call(this, $(a.currentTarget).attr("href"))
            },
            ajaxLoadForm: function(a) {
                "submit" === a.type && a.preventDefault();
                var d = [];
                this.$container[0].querySelectorAll("[data-filter-form] input, [data-filter-form] select").forEach(a=>{
                    ("checkbox" !== a.type && "radio" !== a.type || a.checked) && "" !== a.value && ("" === a.value && a.dataset.currentValue ? d.push([a.name, encodeURIComponent(a.dataset.currentValue)]) : d.push([a.name, encodeURIComponent(a.value)]))
                }
                ),
                this.$container[0].querySelectorAll("[data-filter-form] [data-current-value]").forEach(a=>{
                    a.setAttribute("value", a.dataset.currentValue)
                }
                );
                var b = new FormData(a.currentTarget)
                  , c = new URLSearchParams(b).toString();
                this.functions.ajaxLoadUrl.call(this, "?" + c)
            },
            ajaxPopState: function(a) {
                this.functions.ajaxLoadUrl.call(this, document.location.href)
            },
            initFilterResults: function() {
                this.$container.data("use-infinite-scroll") && this.functions.initInfiniteScroll(),
                theme.loadProductGrid(this.$container),
                theme.initAnimateOnScroll();
                var a = this.$container.closest("[data-components]");
                a.length && a.data("components").split(",").forEach((function(b) {
                    $(document).trigger("cc:component:load", [b, a[0]])
                }
                ).bind(this))
            },
            refreshSelects: function() {
                $("select:not(.original-selector)", this.$container).selectReplace().closest(".selector-wrapper").addClass("has-pretty-select")
            },
            ajaxLoadUrl: function(b) {
                var e = this
                  , a = b;
                "/" === a.slice(0, 1) && (a = window.location.protocol + "//" + window.location.host + a);
                var c = "[data-ajax-container]"
                  , f = this.$container.find(".product-list-toolbar")
                  , d = this.$container.find(c);
                d.addClass("cc-product-filter-container--loading"),
                this.currentAjaxLoadUrlFetch && this.currentAjaxLoadUrlFetch.abort(),
                this.currentAjaxLoadUrlFetch = $.get(b, (function(b) {
                    this.currentAjaxLoadUrlFetch = null;
                    var g = $($.parseHTML(b)).filter("title").text().trim();
                    if (document.title = g,
                    window.history.pushState({
                        path: a
                    }, g, a),
                    document.activeElement && (this.activeElementId = document.activeElement.id),
                    $("<div>".concat(b, "</div>")).find(c).each(function(a) {
                        var b = $(this);
                        $(d[a]).find(".cc-accordion-item").each(function() {
                            var a = $(this).closest(".cc-accordion").index();
                            $(this).hasClass("is-open") ? b.find(".cc-accordion:nth-child(".concat(a + 1, ") .cc-accordion-item")).addClass("is-open").attr("open", "") : b.find(".cc-accordion:nth-child(".concat(a + 1, ") .cc-accordion-item")).removeClass("is-open").removeAttr("open")
                        }),
                        $(".cc-product-filter", e.$container).length && $(".cc-product-filter", e.$container).hasClass("-in") && b.find(".cc-product-filter").addClass("-in"),
                        $(d[a]).html(b.html())
                    }),
                    f && (0 === $("<div>".concat(b, "</div>")).find(".product-list-toolbar").length ? f.hide() : f.show()),
                    this.functions.initFilterResults.call(this),
                    d.removeClass("cc-product-filter-container--loading"),
                    this.activeElementId) {
                        var h = document.getElementById(this.activeElementId);
                        h && h.focus()
                    }
                    var i = $("[data-ajax-scroll-to]:first", this.$container);
                    if ($(window).scrollTop() - 200 > i.offset().top) {
                        if (this.$container.data("is-sticky"))
                            var j = theme.viewport.isSm() ? 25 : 0;
                        else
                            var j = $('.header-container[data-is-sticky="true"]').outerHeight();
                        theme.viewport.scrollTo(i, -1, 1e3, j)
                    }
                }
                ).bind(this))
            }
        },
        this.onSectionUnload = function(a) {
            $("select.replaced", a).selectReplace("destroy"),
            theme.unloadProductGrid(a)
        }
    }
    ,
    theme.CollectionListingSection = new function() {
        this.onSectionLoad = function(a) {
            $(window).trigger("normheights"),
            theme.loadProductGrid(a)
        }
        ,
        this.onSectionUnload = function(a) {
            theme.unloadProductGrid(a)
        }
    }
    ,
    theme.FeaturedCollectionSection = new function() {
        this.onSectionLoad = function(a) {
            theme.loadProductGrid(a)
        }
        ,
        this.onSectionUnload = function(a) {
            theme.unloadProductGrid(a)
        }
    }
    ,
    theme.FeaturedCollectionsSection = new function() {
        this.onSectionLoad = function(a) {
            $(window).trigger("normheights"),
            theme.loadProductGrid(a)
        }
        ,
        this.onSectionUnload = function(a) {
            theme.unloadProductGrid(a)
        }
    }
    ,
    theme.GallerySection = new function() {
        this.onSectionLoad = function(a) {
            var c = $(".gallery--mobile-carousel", a);
            if (c.length) {
                var b = function() {
                    var b = c.hasClass("slick-slider")
                      , a = theme.viewport.isXs();
                    if (a || $(".lazyload--manual", c).removeClass("lazyload--manual").addClass("lazyload"),
                    b && !a) {
                        c.slick("unslick").off("init"),
                        c.find("a, .gallery__item").removeAttr("tabindex").removeAttr("role");
                        var d = c.data("grid")
                          , e = null;
                        c.find(".gallery__item").each(function(a) {
                            a % d == 0 && (e = $('<div class="gallery__row">').appendTo(c)),
                            $(this).appendTo(e)
                        })
                    } else
                        !b && a && (c.find(".gallery__item").appendTo(c),
                        c.find(".gallery__row").remove(),
                        c.on("init", function() {
                            $(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload")
                        }).slick({
                            autoplay: !1,
                            fade: !1,
                            infinite: !1,
                            useTransform: !0,
                            arrows: !1,
                            dots: !0
                        }))
                };
                b(),
                $(window).on("debouncedresize.themeSection" + a.id, b)
            }
        }
        ,
        this.onSectionUnload = function(a) {
            $(window).off(".themeSection" + a.id),
            $(".slick-slider", a).each(function() {
                $(this).slick("unslick").off("init")
            })
        }
        ,
        this.onBlockSelect = function(a) {
            $(a).closest(".slick-slider").each(function() {
                $(this).slick("slickGoTo", $(this).data("slick-index")).slick("slickPause")
            })
        }
        ,
        this.onBlockDeselect = function(a) {
            $(a).closest(".slick-slider").each(function() {
                $(this).slick("slickPlay")
            })
        }
    }
    ,
    theme.HeaderSection = new function() {
        this.onSectionLoad = function(a) {
            if($('#mobile-nav').length == 0){
            $("body").append($("#mobile-navigation-template", a).html());
            }
            var h = $("#localization_form_header");
            if (h.length) {
                var m = $("#localization--mobile-menu")
                  , n = $(".localization--header")
                  , i = function() {
                    theme.viewport.isXs() ? h.appendTo(m) : 0 === n.find("#localization_form_header").length && (h.appendTo(n),
                    n.removeAttr("style"))
                };
                if (i(),
                window.matchMedia) {
                    var d = window.matchMedia("(min-width: 768px)");
                    d.addEventListener && d.addEventListener("change", a=>{
                        a.matches,
                        i()
                    }
                    )
                }
            }
            function o() {
                $(this).attr("aria-expanded", !$(this).siblings().is(":visible")),
                $(this).parent().toggleClass("sub-nav-item--expanded", !$(this).siblings().is(":visible")),
                $(this).siblings().slideToggle(250)
            }
            if ($("#mobile-nav .sub-nav a, #mobile-nav .sub-nav button").attr("tabindex", "-1"),
            $(".main-nav", a).length) {
                $(".main-nav .sub-nav-item.has-dropdown > a", a).on("keypress", function(a) {
                    32 === a.keyCode && o.call(this),
                    a.preventDefault()
                }),
                $(".main-nav", a).on("click", ".sub-nav-item.has-dropdown > a", function() {
                    return o.call(this),
                    !1
                }).filter("[data-col-limit]").each(function() {
                    var a = $(this).data("col-limit");
                    a > 0 && $(".nav-item.dropdown.drop-norm > .sub-nav", this).each(function() {
                        for (var c = $(this).find(".sub-nav-list:not(.sub-nav-image) > .sub-nav-item"), d = Math.ceil(c.length / a), b = 1; b < d; b++)
                            $('<ul class="sub-nav-list"/>').append(c.slice(a * b)).insertAfter($(this).find(".sub-nav-list:not(.sub-nav-image):last"))
                    })
                });
                var p, q = 250, r = $(), s = -1;
                $(a),
                $(".main-nav", a).on("mouseenter mouseleave", ".nav-item.dropdown", function(b) {
                    var a = $(b.currentTarget);
                    if ("mouseenter" == b.type) {
                        clearTimeout(s),
                        clearTimeout(a.data("navCloseTimeoutId"));
                        var c = a.siblings(".open");
                        c.not(r).removeClass("open"),
                        r = a;
                        var e = 0 == c.length ? 0 : q
                          , d = setTimeout(function() {
                            a.addClass("open").siblings(".open").removeClass("open");
                            var b = a.filter(".drop-norm").children(".sub-nav");
                            if (b.length) {
                                var d = ""
                                  , f = $("#page-wrap").width() - 30;
                                if (a.closest(".align-center").length) {
                                    var g = a.offset().left + a.outerWidth() / 2 - b.outerWidth() / 2 - 30;
                                    if (g < 0)
                                        d = "translateX(calc(50% + " + Math.round(Math.abs(g)) + "px))";
                                    else {
                                        var e = a.offset().left + a.outerWidth() / 2 + b.outerWidth() / 2
                                          , c = e - f;
                                        c > 0 && (d = "translateX(calc(50% - " + Math.round(c) + "px))")
                                    }
                                } else {
                                    var e = a.offset().left + b.outerWidth()
                                      , c = e - f;
                                    c > 0 && (d = "translateX(-" + Math.round(c) + "px)")
                                }
                                b.css("transform", d)
                            }
                        }, e);
                        s = d,
                        a.data("navOpenTimeoutId", d)
                    } else
                        clearTimeout(a.data("navOpenTimeoutId")),
                        a.data("navCloseTimeoutId", setTimeout(function() {
                            a.removeClass("open").children(".sub-nav").css("transform", "")
                        }, q));
                    a.children("[aria-expanded]").attr("aria-expanded", "mouseenter" == b.type)
                }),
                $(".main-nav", a).on("touchstart touchend click", ".nav-item.dropdown > .nav-item-link", function(a) {
                    if ("touchstart" == a.type)
                        $(this).data("touchstartedAt", a.timeStamp);
                    else if ("touchend" == a.type) {
                        if (a.timeStamp - $(this).data("touchstartedAt") < 1e3)
                            return $(this).data("touchOpenTriggeredAt", a.timeStamp),
                            $(this).parent().hasClass("open") ? $(this).parent().trigger("mouseleave") : ($(".nav-item.open").trigger("mouseleave"),
                            $(this).parent().trigger("mouseenter")),
                            !1
                    } else if ("click" == a.type && $(this).data("touchOpenTriggeredAt") && a.timeStamp - $(this).data("touchOpenTriggeredAt") < 1e3)
                        return !1
                }),
                $(".main-nav", a).on("keydown", ".nav-item.dropdown > .nav-item-link", function(a) {
                    if (32 == a.which) {
                        var b = $(a.target).parent();
                        return b.trigger(b.hasClass("open") ? "mouseleave" : "mouseenter"),
                        !1
                    }
                });
                var t = $("#logo-spacer", a)
                  , u = $(".logo-item", a);
                function j() {
                    $(window).width() !== p && (setTimeout(function() {
                        var a = $(".main-nav").width() + $(".main-nav").offset().left;
                        $(".main-nav .nav-item.drop-norm .sub-nav").css("transform", "").each(function() {
                            $(this).css({
                                visibility: "hidden",
                                zIndex: -1
                            }).css({
                                display: "block"
                            });
                            var b = a - ($(this).offset().left + $(this).outerWidth())
                              , c = $(this).offset().left;
                            b < 0 ? $(this).css("transform", "translate(" + Math.ceil(b - 1) + "px)") : c < 0 && $(this).css("transform", "translate(" + Math.ceil(-c) + "px)"),
                            $(this).css({
                                visibility: "",
                                zIndex: "",
                                display: ""
                            })
                        })
                    }, 50),
                    p = $(window).width())
                }
                $(window).on("debouncedresize.headerSection doNavResizeEvents.headerSection", function() {
                    t.length && u.length && t.css("width", u.outerWidth())
                }).trigger("doNavResizeEvents"),
                $(window).on("debouncedresize.headerSection ensuredropdownposition.headerSection", j).trigger("ensuredropdownposition"),
                $(function() {
                    j()
                })
            }
            $("select:not([name=id])", a).selectReplace(),
            $(".disclosure", a).add("#mobile-nav .disclosure").each(function() {
                $(this).data("disclosure", new theme.Disclosure($(this)))
            });
            var b = $('.main-search[data-live-search="true"]', a)
              , v = b.find("form")
              , e = b.find(".main_search__popup")
              , w = b.find(".main-search__results")
              , x = e.find(".main-search__footer-buttons")
              , y = e.find(".all-results-container");
            if (b.length) {
                var z = $(".main-search__input", a)
                  , c = theme.utils.getUrlParameter("filter.p.product_type");
                if (c && c.length > 0) {
                    var f = $(".main-search__product-types", a);
                    f && f.val(c).trigger("change")
                }
                var k = new function() {
                    return {
                        popup: {
                            show: function() {
                                var c = arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
                                  , a = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                                  , d = !(arguments.length > 2) || void 0 === arguments[2] || arguments[2];
                                (w.html().length > 0 || !0 === c || !0 === a || z.val().length >= 3) && ((0 === w.html().length || !0 === a) && !0 === d && J.call(z),
                                b.addClass("main-search--show-popup")),
                                e.attr("aria-expanded", !0)
                            },
                            hide() {
                                b.removeClass("main-search--show-popup"),
                                e.attr("aria-expanded", !1)
                            }
                        },
                        hiddenSearch: {
                            hide() {
                                var a = b.closest(".hidden-search-container");
                                a.length > 0 && (a.removeClass("hidden-search-container--open"),
                                $("body").removeClass("hidden-search-container--open"))
                            }
                        }
                    }
                }
                  , A = 500
                  , B = -1
                  , C = null
                  , D = b.data("live-search-price")
                  , E = b.data("live-search-vendor")
                  , F = b.data("live-search-meta")
                  , G = b.data("show-sold-out-label")
                  , H = b.data("show-sale-label")
                  , I = null;
                function J() {
                    var b = $(this).closest(".main-search")
                      , g = b.find(".main-search__results")
                      , c = b.find(".main-search__product-types:visible")
                      , a = $(this).val()
                      , d = c.length > 0 ? c.val() : "";
                    if (a.length > 2 && (a != z.data("oldval") || 0 === c.length || d != z.data("oldtype"))) {
                        z.data("oldval", a),
                        z.data("oldtype", d),
                        null != C && C.abort(),
                        clearTimeout(B);
                        var f = $(this).closest("form").eq(0)
                          , h = f.attr("action") + (f.attr("action").indexOf("?") > -1 ? "&" : "?") + f.serialize();
                        b.removeClass("main-search--has-results main-search--results-on-multiple-lines main-search--no-results").addClass("main-search--loading"),
                        e.css("height", e.outerHeight() + "px"),
                        k.popup.show(!0, !1, !1),
                        y.empty(),
                        x.hide(),
                        0 === $(".main-search__results-spinner").length && g.html('<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>'),
                        B = setTimeout(function() {
                            var c, i;
                            theme.Shopify.features.predictiveSearch ? (c = theme.routes.search_url + "/suggest.json",
                            i = {
                                q: "".concat(d.length > 0 ? "product_type:" + d + "+*" : "", " ").concat(a),
                                resources: {
                                    type: f.find('input[name="type"]').val(),
                                    limit: 8,
                                    options: {
                                        unavailable_products: "last",
                                        fields: F ? "title,product_type,variants.title,vendor,tag,variants.sku" : "title,product_type,variants.title,vendor"
                                    }
                                }
                            }) : (c = h + "&view=json",
                            i = null),
                            C = $.ajax({
                                url: c,
                                data: i,
                                dataType: "json",
                                success: function(f) {
                                    C = null,
                                    b.removeClass("main-search--has-results main-search--results-on-multiple-lines main-search--no-results"),
                                    g.empty();
                                    var k = $('<div class="main-search__results__products collection-listing"><div class="product-list product-list--per-row-4 product-list--image-shape-natural"></div></div>')
                                      , j = $('<div class="main-search__results__pages">');
                                    if (f.resources.results.products)
                                        for (var d = 0; d < f.resources.results.products.length; d++) {
                                            var a = f.resources.results.products[d]
                                              , c = $('<div class="main-search-result"><div class="block-inner"><div class="block-inner-inner"><div class="image-cont"><a class="product-link"><div class="image-label-wrap"><div class="primary-image"></div></div></a></div><div class="product-info"><div class="inner"><div class="innerer"><a class="product-link"><div class="product-block__title"></div></a></div></div></div></div></div></div>');
                                            if (c.find(".product-link").attr("href", a.url),
                                            a.featured_image && a.featured_image.url) {
                                                var m = $('<div class="rimage-outer-wrapper"><div class="rimage-wrapper lazyload--placeholder"><img loading="lazy" class="rimage__image"/></div></div>').appendTo(c.find(".primary-image"));
                                                m.find(".rimage-wrapper").css("padding-top", 1 / Math.max(a.featured_image.aspect_ratio, .6) * 100 + "%"),
                                                m.find(".rimage__image").attr("data-lazy-src", theme.Shopify.formatImage(a.featured_image.url, "{width}x"))
                                            }
                                            var l = c.find(".product-info .product-link");
                                            if (l.find(".product-block__title").html(a.title),
                                            E && $('<div class="vendor">').html(a.vendor).prependTo(l),
                                            D) {
                                                var i = $('<div class="product-price">').appendTo(l);
                                                a.price_max != a.price_min && ($('<span class="product-price__from">').html(theme.strings.products_listing_from).appendTo(i),
                                                i.append(" ")),
                                                parseFloat(a.compare_at_price_min) > parseFloat(a.price_min) ? ($('<span class="product-price__amount product-price__amount--on-sale theme-money reduced-price">').html(theme.formatMoney(a.price_min)).appendTo(i),
                                                i.append(" "),
                                                $('<span class="product-price__compare theme-money struck-out-price">').html(theme.formatMoney(a.compare_at_price_min)).appendTo(i)) : $('<span class="product-price__amount theme-money">').html(theme.formatMoney(a.price_min)).appendTo(i)
                                            }
                                            G && !a.available ? $('<span class="product-label product-label--soldout"><span>'.concat(theme.strings.products_labels_sold_out, "</span></span>")).appendTo(c.find(".product-info")) : H && parseFloat(a.compare_at_price_min) > parseFloat(a.price_min) && $('<span class="product-label product-label--sale"><span>'.concat(theme.strings.products_labels_sale, "</span></span>")).appendTo(c.find(".product-info")),
                                            k.children().append(c)
                                        }
                                    if (f.resources.results.pages)
                                        for (var d = 0; d < f.resources.results.pages.length; d++) {
                                            var a = f.resources.results.pages[d]
                                              , c = $('<a class="main-search-result main-search-result--page">').attr("href", a.url);
                                            $('<div class="main-search-result__text">').html(a.title).appendTo(c),
                                            j.append(c)
                                        }
                                    if (f.resources.results.articles)
                                        for (var d = 0; d < f.resources.results.articles.length; d++) {
                                            var a = f.resources.results.articles[d]
                                              , c = $('<a class="main-search-result main-search-result--article">').attr("href", a.url);
                                            $('<div class="main-search-result__text">').html(a.title).appendTo(c),
                                            j.append(c)
                                        }
                                    e.css("height", "auto"),
                                    b.removeClass("main-search--loading");
                                    var n = k.find(".main-search-result:first").length > 0
                                      , o = j.find(".main-search-result:first").length > 0;
                                    n || o ? (b.addClass("main-search--has-results"),
                                    b.toggleClass("main-search--results-on-multiple-lines", k.find(".product-block").length > 4),
                                    n && g.append(k),
                                    o && ($('<h6 class="main-search-result__heading">').html(theme.strings.general_quick_search_pages).prependTo(j),
                                    g.append(j)),
                                    $('<a class="main-search__results-all-link btn">').attr("href", h).html(theme.strings.layout_live_search_see_all + theme.icons.chevronRight).appendTo(y),
                                    x.css("display", "flex")) : (b.addClass("main-search--no-results"),
                                    $('<div class="main-search__empty-message">').html(theme.strings.general_quick_search_no_results).appendTo(g))
                                },
                                error: function(a) {
                                    console.log("Error fetching results", a)
                                }
                            })
                        }, A)
                    } else
                        $(this).val().length <= 2 && (z.data("oldval", a),
                        z.data("oldtype", d),
                        null != C && C.abort(),
                        clearTimeout(B),
                        k.popup.hide(),
                        setTimeout(()=>{
                            e.css("height", "auto"),
                            b.removeClass("main-search--has-results main-search--results-on-multiple-lines main-search--loading"),
                            g.empty(),
                            y.empty(),
                            x.hide()
                        }
                        , 50))
                }
                $(a).on("keyup.headerSection change.headerSection", ".main-search__input:visible", function() {
                    $(this).closest(".hidden-search-container--mob-only").length ? theme.viewport.isXs() && J.call(this) : I !== $(this).val() && (J.call(this),
                    I = $(this).val())
                }),
                $(a).on("click.headerSection", ".main-search__input", k.popup.show),
                $(a).on("focus.headerSection", ".main-search__input", function() {
                    k.popup.show(),
                    $(this).select()
                }),
                $(a).on("change.headerSection", ".main-search__product-types", function() {
                    z.val().length >= 3 && k.popup.show(!0, !0)
                }),
                $(a).on("click.headerSection", ".main-search__results-close-link", function() {
                    return k.popup.hide(),
                    k.hiddenSearch.hide(),
                    !1
                });
                var l = $(".hidden-search-container", a)
                  , K = $(".hidden-search-container .main-search", a);
                if (l.length) {
                    var L = $("#toolbar", a).closest(".container");
                    function g() {
                        theme.viewport.isXs() && $(".hidden-search-container .main-search", a).length > 0 ? L.append(K.addClass("main-search--revealable")) : theme.viewport.isSm() && 0 === $(".hidden-search-container .main-search", a).length && l.append(K.removeClass("main-search--revealable").css("display", ""))
                    }
                    $(a).on("click.headerSection", "[data-show-search-form]", function() {
                        return l.find(".main-search").length ? (l.addClass("hidden-search-container--open"),
                        $("body").addClass("hidden-search-container--open"),
                        setTimeout(()=>{
                            l.find(".main-search__input").focus()
                        }
                        , 100)) : theme.browser.isSafari() ? (L.find(".main-search").toggleClass("-in").show(),
                        L.find(".main-search__input").focus()) : L.find(".main-search").slideToggle(200, function() {
                            setTimeout(()=>{
                                L.find(".main-search__input").focus()
                            }
                            , 100)
                        }).toggleClass("-in"),
                        !1
                    }),
                    $(window).on("debouncedresize.headerSection", g),
                    g()
                }
                $(a).on("keyup.headerSection", a=>{
                    27 === a.which && (k.popup.hide(),
                    k.hiddenSearch.hide())
                }
                ),
                $("body").on("click.headerSection", a=>{
                    0 === v.has(a.target).length && (k.popup.hide(),
                    k.hiddenSearch.hide())
                }
                )
            }
            if(MC.length){
                var M = [];
                for(var i = 0; i<MC.length; i++){
                    M.push($(MC[i]));
                }
            }else{
            var M = [];
            }
            $(document).on("click", "#mobile-nav .open-sub-nav", function() {
                var a = $("#mobile-nav .inner:not(.hide), #mobile-nav .sub-nav.show:not(.hide)").addClass("hide");
                return a.find("a, button").attr("tabindex", "-1"),
                M.push(a),
                $('#mobile-nav .sub-nav[data-is-subnav-for="' + $(this).data("sub-nav") + '"]').first().addClass("show").find("a, button").removeAttr("tabindex"),
                $(this).attr("aria-expanded", !0),
                !1
            }).on("click", "#mobile-nav .close-sub-nav", function() {
                $(this).closest(".sub-nav").removeClass("show").find("a, button").attr("tabindex", "-1");
                var a = M.pop().removeClass("hide");
                return a.find("a, button").removeAttr("tabindex"),
                a.find('[aria-expanded="true"]').removeAttr("aria-expanded"),
                !1
            }).on("click", '#mobile-nav a.nav-item-link[href="#"], #mobile-nav a.sub-nav-item-link[href="#"]', function() {
                return $(this).closest("li").find("button").click(),
                !1
            })
        }
        ,
        this.onSectionUnload = function(a) {
            $(".main-nav", a).off("click mouseenter mouseleave touchstart touchend keydown"),
            $("#mobile-nav").remove(),
            $(window).off(".headerSection"),
            $(a).off(".headerSection"),
            $(".disclosure", a).add("#mobile-nav .disclosure").each(function() {
                $(this).data("disclosure").unload()
            }),
            $("select.replaced", a).selectReplace("destroy")
        }
    }
    ,
    theme.AnnouncementBarSection = new function() {
        this.onSectionLoad = function(a) {
            $(".disclosure", a).each(function() {
                $(this).data("disclosure", new theme.Disclosure($(this)))
            });
            var c = $(".announcement-bar__spacer", a);
            if (c.length > 1) {
                function b() {
                    var a = 0;
                    c.each(function() {
                        $(this).width() > a && (a = $(this).width())
                    }),
                    c.width(parseInt(a))
                }
                $(window).on("debouncedresize.announcementBarSection", b),
                b()
            }
        }
        ,
        this.onSectionUnload = function(a) {
            $(".disclosure", a).each(function() {
                $(this).data("disclosure").unload()
            }),
            $(window).off(".announcementBarSection")
        }
    }
    ,
    theme.BlogTemplateSection = new function() {
        this.onSectionLoad = function(a) {
            if ($("select:not([name=id])", a).selectReplace(),
            $(".use-masonry", a).each(function() {
                var a = $(this);
                window.$ = window.jQuery = $,
                theme.loadScriptOnce(theme.scripts.masonry, function() {
                    a.addClass("masonry").masonry({
                        itemSelector: ".article",
                        visibleStyle: {
                            opacity: 1,
                            transform: "translate3d(0,0,0)"
                        },
                        hiddenStyle: {
                            opacity: 0,
                            transform: "translate3d(0,20px,0)"
                        }
                    }),
                    setTimeout(function() {
                        $(function() {
                            a.masonry()
                        })
                    }, 10)
                })
            }),
            $(".articles.use-infinite-scroll", a).each(function() {
                var a = $(this);
                window.$ = window.jQuery = $,
                theme.loadScriptOnce(theme.scripts.jqueryInfiniteScroll, function() {
                    a.infinitescroll({
                        navSelector: ".pagination",
                        nextSelector: ".pagination .next",
                        itemSelector: ".articles .article",
                        loading: {
                            msgText: theme.strings.infiniteScrollBlogLoading,
                            finishedMsg: theme.strings.infiniteScrollBlogFinishedMsg
                        },
                        pathParse: function(a, b) {
                            return a.match(/^(.*page=)[0-9]*(&.*)?$/).splice(1)
                        }
                    }, function(b) {
                        a.find("#infscr-loading").remove(),
                        a.hasClass("masonry") && $(b).hide().imagesLoaded(function() {
                            $(b).show(),
                            a.masonry("appended", $(b), !0)
                        }),
                        theme.initAnimateOnScroll()
                    })
                })
            }),
            $(".page-title.opposing-items .tags", a).length > 0) {
                function b() {
                    var a = $(".page-title.opposing-items")
                      , c = a.children(".left")
                      , b = a.children(".tags");
                    a.toggleClass("collapse-tags", b.outerWidth(!0) > a.width() - c.outerWidth(!0)),
                    a.hasClass("collapse-tags") ? 0 == a.find(".more-link").length && b.before(['<a href="#" class="more-link">', theme.strings.blogsShowTags, "</a>"].join("")) : a.find(".more-link").remove()
                }
                $(window).on("debouncedresize.checktagswidth checktagswidth.checktagswidth", b).trigger("checktagswidth"),
                $(function() {
                    b()
                }),
                $(document).on("click.checktagswidth", ".page-title.opposing-items.collapse-tags .more-link", function(a) {
                    a.preventDefault(),
                    $(this).closest(".opposing-items").toggleClass("reveal-tags")
                })
            }
        }
        ,
        this.onSectionUnload = function(a) {
            $(window).off(".checktagswidth .blogTemplateMasonry"),
            $(document).off(".checktagswidth"),
            $("select.replaced", a).selectReplace("destroy")
        }
    }
    ,
    theme.CartTemplateSection = new function() {
        this.onSectionLoad = function(a) {
            var b = this;
            this.namespace = theme.namespaceFromSection(a),
            $("#shipping-calculator", a).length && theme.loadScriptOnce(theme.scripts.underscore, function() {
                theme.loadScriptOnce(theme.scripts.shopifyCommon, function() {
                    theme.loadScriptOnce(theme.scripts.jqueryCart, (function() {
                        Shopify.Cart.ShippingCalculator.show({
                            submitButton: theme.strings.shippingCalcSubmitButton,
                            submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                            customerIsLoggedIn: theme.customerIsLoggedIn,
                            moneyFormat: theme.shippingCalcMoneyFormat
                        }),
                        $("select", this).selectReplace(),
                        setTimeout((function() {
                            this.trigger("change")
                        }
                        ).bind($("select", this)), 100)
                    }
                    ).bind(a))
                }, null, !0)
            }, null, !0),
            $(a).on("click".concat(this.namespace), ".qty-adjuster__remove", function() {
                return !!confirm(theme.strings.cartConfirmRemove) && (!$(a).data("ajax-update") || (b.functions.updateCart.call(this, {
                    line: $(this).data("line"),
                    quantity: 0
                }),
                !1))
            }),
            $(a).data("ajax-update") && ($(document).on("theme:cartchanged.cartTemplateSection", this.functions.refreshCartDependentContent.bind(this)),
            $(a).on("change".concat(this.namespace, " changeFromButton").concat(this.namespace), ".qty-adjuster__value", (function(b) {
                var c, a = $(b.currentTarget);
                this.replacingContent || a.data("initial-value") && a.data("initial-value") === a.val() || 0 === a.val().length || (c = "changeFromButton" === b.type ? $(b.data).attr("id") : a.attr("id"),
                a.closest(".cart-item").addClass("cart-item-loading"),
                this.functions.updateCart.call(this, {
                    line: a.data("line"),
                    quantity: a.val()
                }, function() {
                    $("#" + c).focus()
                }))
            }
            ).bind(this))),
            theme.loadCartNoteMonitor(a)
        }
        ,
        this.functions = {
            refreshCartDependentContent: function() {
                this.cartRefreshXhr && this.cartRefreshXhr.abort(),
                this.cartRefreshXhr = $.ajax({
                    type: "GET",
                    url: theme.routes.cart_url + "?view=ajax",
                    success: (function(d) {
                        var b = [".cart-items", ".cart-subtotal"]
                          , c = $("<div>" + d + "</div>");
                        c.find("[data-cc-animate]").removeAttr("data-cc-animate");
                        for (var a = 0; a < b.length; a++)
                            c.find(b[a]).length ? (this.replacingContent = !0,
                            $('[data-section-type="cart-template"] ' + b[a]).html(c.find(b[a]).html())) : $('[data-section-type="cart-template"]').html(c.find('[data-section-type="cart-template"]').html()),
                            this.replacingContent = !1
                    }
                    ).bind(this),
                    error: function(a) {
                        "abort" != a.statusText && (console.error("Error refreshing page", a),
                        $("#cartform").submit())
                    },
                    complete: (function() {
                        this.cartRefreshXhr = null
                    }
                    ).bind(this)
                })
            },
            updateCart: function(a, b) {
                this.cartXhr && this.cartXhr.abort(),
                this.cartRefreshXhr && this.cartRefreshXhr.abort(),
                this.cartXhr = $.ajax({
                    type: "POST",
                    url: theme.routes.cart_change_url + ".js",
                    data: a,
                    dataType: "json",
                    success: function() {
                      Shopify.getCart(function(cart) {
                        document.documentElement.dispatchEvent(new CustomEvent("theme:cartchanged",{
                            bubbles: !0,
                            cancelable: !1
                        })),
                        b && b()
                      }.bind(this));  
                    },
                    error: function(a) {
                        "abort" != a.statusText && (console.error("Error updating cart", a),
                        $("#cartform").submit())
                    },
                    complete: (function() {
                        this.cartXhr = null
                    }
                    ).bind(this)
                })
            }
        },
        this.onSectionUnload = function(a) {
            $("#shipping-calculator #address_country", a).off("change"),
            $("#shipping-calculator .get-rates", a).off("click"),
            $("select.replaced", a).selectReplace("destroy"),
            theme.unloadCartNoteMonitor(a)
        }
    }
    ,
    theme.ProductRecommendations = new function() {
        this.onSectionLoad = function(c) {
            var b = c;
            if (null !== b) {
                var a = new XMLHttpRequest;
                a.open("GET", b.dataset.url, !0),
                a.onload = function() {
                    if (a.status >= 200 && a.status < 300) {
                        var c = document.createElement("div");
                        c.innerHTML = a.response,
                        b.innerHTML = c.querySelector(".product-recommendations").innerHTML,
                        theme.loadProductGrid(b)
                    }
                }
                ,
                a.send()
            }
        }
    }
    ,
    theme.TestimonialsSection = new function() {
        this.onSectionLoad = function(a) {
            theme.initContentSlider(a)
        }
        ,
        this.onSectionUnload = function(a) {
            $(".slick-slider", a).slick("unslick").off("init"),
            $(window).off(".testimonialsSection")
        }
        ,
        this.onBlockSelect = function(a) {
            $(a).closest(".slick-slider").slick("slickGoTo", $(a).data("slick-index")).slick("slickPause")
        }
        ,
        this.onBlockDeselect = function(a) {
            $(a).closest(".slick-slider").slick("slickPlay")
        }
    }
    ,
    $(function($) {
        $(document).on("keyup.themeTabCheck", function(a) {
            9 === a.keyCode && ($("body").addClass("tab-used"),
            $(document).off("keyup.themeTabCheck"))
        }),
        $("select:not([name=id])").filter(function() {
            $(this).closest(".product-form").length
        }).selectReplace(),
        theme.uncontainImages($("body")),
        $("a[rel=lightbox]").colorbox({
            minWidth: "200",
            maxWidth: "96%",
            maxHeight: "96%"
        }),
        theme.carousels.init(),
        function(){
            try{
                theme.assessFullWidthSections()
            }
            catch(error){
                console.log(error.message);
            }
        },
        $(document).on("shopify:section:reorder", function(a) {
            theme.assessFullWidthSections()
        }),
        $(document).on("shopify:section:load", function(a) {
            theme.uncontainImages(a.target),
            theme.assessFullWidthSections(),
            theme.carousels.init(),
            $(".section-background-video--inline", a.target).each(function() {
                theme.VideoManager.onSectionLoad($(this)[0])
            })
        }),
        $(document).on("shopify:section:unload", function(a) {
            $(".section-background-video--inline", a.target).each(function() {
                theme.VideoManager.onSectionUnload($(this)[0])
            }),
            theme.carousels.destroy()
        }),
        $(document).on("change", "select.redirect", function() {
            window.location = $(this).val()
        }),
        $(document).on("click", ".sharing a", function(g) {
            var h = $(this).parent();
            if (h.hasClass("twitter")) {
                g.preventDefault();
                var c = $(this).attr("href")
                  , a = 575
                  , b = 450
                  , d = ($(window).width() - a) / 2
                  , e = ($(window).height() - b) / 2
                  , f = "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" + a + ",height=" + b + ",top=" + e + ",left=" + d;
                window.open(c, "Twitter", f)
            } else if (h.hasClass("facebook")) {
                g.preventDefault();
                var c = $(this).attr("href")
                  , a = 626
                  , b = 256
                  , d = ($(window).width() - a) / 2
                  , e = ($(window).height() - b) / 2
                  , f = "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" + a + ",height=" + b + ",top=" + e + ",left=" + d;
                window.open(c, "Facebook", f)
            } else if (h.hasClass("pinterest")) {
                g.preventDefault();
                var c = $(this).attr("href")
                  , a = 700
                  , b = 550
                  , d = ($(window).width() - a) / 2
                  , e = ($(window).height() - b) / 2
                  , f = "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" + a + ",height=" + b + ",top=" + e + ",left=" + d;
                window.open(c, "Pinterest", f)
            }
        }),
        $(document).on("click", "#page-overlay, .side-menu-header--close", function() {
            return $("body").removeClass("show-cart-summary show-mobile-nav product-added-to-cart"),
            setTimeout(function() {
                $(".sub-nav").removeClass("show"),
                $("#mobile-nav .inner, #mobile-nav .sub-nav").removeClass("hide")
            }, 500),
            !1
        }),
        $(document).on("click", ".toggle-mob-nav", function() {
            return $(".cart-summary").removeClass("active"),
            $("#mobile-nav").addClass("active"),
            $("body").toggleClass("show-mobile-nav").hasClass("show-mobile-nav") ? setTimeout(function() {
                $("#mobile-nav").attr("tabindex", "0").focus()
            }, 500) : setTimeout(function() {
                $("#mobile-nav").removeAttr("tabindex"),
                $("body a:first:visible").focus()
            }, 500),
            !1
        }),
        "off" != theme.useSideCartSummary && $(document).on("click", ".toggle-cart-summary", function() {
            if ($(".cart-summary .toggle-cart-summary").is(":visible"))
                return $("#mobile-nav").removeClass("active"),
                $(".cart-summary").addClass("active"),
                $("body").removeClass("product-added-to-cart"),
                $("body").toggleClass("show-cart-summary").hasClass("show-cart-summary") && setTimeout(function() {
                    $(".cart-summary__close").focus()
                }, 200),
                !1
        }),
        $(document).on("keypress", ".qty-adjuster--ajax .qty-adjuster__value", function(a) {
            return 13 === a.which ? ($(this).trigger("change"),
            !1) : (8 === a.which || 0 === a.which || !(a.which < 48) && !(a.which > 57)) && void 0
        }),
        $(document).on("click", ".qty-adjuster__down, .qty-adjuster__up", function(e) {
            e.preventDefault();
            var c = $(this).closest(".qty-adjuster")
              , b = c.find(".qty-adjuster__value")
              , d = parseInt(b.val()) + ($(this).hasClass("qty-adjuster__down") ? -1 : 1)
              , a = $(this).closest("[data-limit]").attr("data-limit");
            a && (a = parseInt(a)),
            a && d > a ? (theme.showQuickPopup(theme.strings.maximumQuantity.replace("[quantity]", a), b),
            b.val(a).trigger("change")) : b.val(d).trigger("change"),
            theme.updateAdjusterButtonsDisabledState(c, !1)
        }),
        $(document).on("click", ".qty-adjuster--ajax .qty-adjuster__remove", function(b) {
            b.preventDefault(),
            $(this).closest(".qty-adjuster").find(".qty-adjuster__value").val(0).trigger("change");
            var a = $(this).closest(".cart-summary-item-container");
            a.addClass("cart-summary-item-container--out"),
            a.slideUp(300)
        }),
        $(document).on("click", '.btn[data-btn-type="in-cart"]', function(b) {
            b.preventDefault();
            var a = $(this).closest("form");
            a.find(":submit").attr("disabled", "disabled").each(function() {
                $(this).addClass("product-add--adding")
            }),
            $('.cart-form .cart-summary-item-container[data-product-id="'.concat(a.find('select[name="id"]').val(), '"] .qty-adjuster__remove')).trigger("click")
        });
        var c = theme.debounce(function() {
            var a = $(this).closest(".qty-adjuster").attr("data-line-item-id")
              , c = $('.qty-adjuster[data-line-item-id="'.concat(a, '"]'));
            theme.disableInPlaceQuantityAdjustment(c),
            theme.cartLoadingStarted();
            var b = $('.product-form--not-quickbuy .qty-adjuster[data-line-item-id="'.concat(a, '"]')).closest("form");
            b.length && b.find(":submit").attr("disabled", "disabled").each(function() {
                $(this).addClass("product-add--adding")
            }),
            $.post(theme.routes.cart_url + "/change.js", {
                quantity: $(this).val(),
                id: a
            }, function(a) {
                Shopify.getCart(function(a) {
                    theme.updateCartSummaries(!1)
                }.bind(this))
            }, "json").fail(function() {
                theme.enableInPlaceQuantityAdjustment(c)
            }).always(function() {
                0 == c.find(".qty-adjuster__value").val() && theme.enableInPlaceQuantityAdjustment(c),
                theme.cartLoadingFinished()
            })
        });
        function a() {
            $("[data-normheights]").each(function() {
                var a = $(this).find($(this).data("normheights"))
                  , d = $(this).data("normheights-inner")
                  , b = 0
                  , e = 0
                  , c = [];
                a.each(function(g) {
                    var h = $(this).find(d)
                      , a = $(this).position().top;
                    0 == g ? e = a : a != e && ($(c).css("min-height", b),
                    a = $(this).position().top,
                    c.length = 0,
                    b = 0),
                    e = a,
                    c.push(this);
                    var f = h.height();
                    f > b && (b = f)
                }),
                $(c).css("min-height", b)
            }),
            $(".product-grid").each(function() {
                var a = $(this).find(".product-block .product-block__weight")
                  , b = 0;
                a.each(function() {
                    b += $(this).text().replace("&nbsp;", "").trim().length
                }),
                0 === b && a.remove()
            }),
            $(".product-grid.one-row").each(function() {
                var b = 0
                  , a = $(this).find(".product-block:not(.product-block--flex-spacer)");
                $(this).css("position", "relative"),
                a.find(".product-block:not(.product-block--flex-spacer)").each(function(c) {
                    if (0 != $(this).position().top)
                        return !1;
                    var a = $(this).outerHeight(!0);
                    a > b && (b = a)
                }),
                $(this).css("height", b),
                a.removeClass("hidden").each(function(a) {
                    $(this).position().top > 0 && $(this).addClass("hidden")
                }),
                $(this).css({
                    height: "",
                    position: ""
                })
            })
        }
        function b() {
            $("#page-wrap-inner").css("min-height", $(window).height())
        }
        $(document).on("change", ".qty-adjuster--ajax .qty-adjuster__value", function(b) {
            var a = $(this).closest("form");
            a.hasClass("product-form--not-quickbuy") ? a.hasClass("product-form--added") && c.call(this) : c.call(this)
        }),
        $(document).on("click", 'a[href^="#"]:not([href="#"]):not(.skip-link):not(.ignore-scroll)', function(b) {
            var a = $($(this).attr("href")).first();
            1 == a.length && ($("html:not(:animated),body:not(:animated)").animate({
                scrollTop: a.offset().top
            }, 500),
            b.preventDefault())
        }),
        theme.utils.cookie.exists("theme_added_to_cart") && "justnow" == theme.utils.cookie.read("theme_added_to_cart") && (theme.utils.cookie.erase("theme_added_to_cart"),
        theme.updateCartSummaries(!1)),
        $(window).on("debouncedresize normheights", a).trigger("normheights"),
        $(function() {
            a()
        }),
        $(document).on("click", "#colorbox .close-box", function() {
            return $.colorbox.close(),
            !1
        }).on("click", "#colorbox .action-icons .prev-item, #colorbox .action-icons .next-item", function() {
            return $("#".concat($(this).data("idx"), " .quick-buy")).click(),
            theme.activeQuickBuyMediaGallery && theme.activeQuickBuyMediaGallery.destroy(),
            !1
        }),
        $(document).on("focusin focusout", ".toolbar .main-search__form input", function(a) {
            $(this).closest(".main-search__form").toggleClass("focus", "focusin" == a.type)
        }),
        $(window).on("debouncedresize setminheight", b).trigger("setminheight"),
        $(function() {
            b()
        }),
        $.extend($.colorbox.settings, {
            previous: theme.strings.colorBoxPrevious,
            next: theme.strings.colorBoxNext,
            close: theme.strings.colorBoxClose
        }),
        document.querySelector(".shopify-challenge__container") && (document.getElementById("page-footer").style.display = "none"),
        theme.device.isTouch() && document.getElementsByTagName("html")[0].classList.add("touch"),
        window.addEventListener("pageshow", function(a) {
            a.persisted && theme.updateCartSummaries(!1, !1, !1)
        }),
        theme.Sections.init(),
        theme.Sections.register("slideshow", theme.SlideshowSection),
        theme.Sections.register("header", theme.HeaderSection, {
            deferredLoad: !1
        }),
        theme.Sections.register("footer", theme.FooterSection),
        theme.Sections.register("cart-drawer", theme.CartDrawerSection, {
            deferredLoad: !1
        }),
        theme.Sections.register("collection-template", theme.FilterManager, {
            deferredLoad: !1
        }),
        theme.Sections.register("product-template", theme.ProductTemplateSection),
        theme.Sections.register("blog-template", theme.BlogTemplateSection, {
            deferredLoad: !1
        }),
        theme.Sections.register("cart-template", theme.CartTemplateSection, {
            deferredLoad: !1
        }),
        theme.Sections.register("collection-listing", theme.CollectionListingSection, {
            deferredLoad: !1
        }),
        theme.Sections.register("featured-collection", theme.FeaturedCollectionSection),
        theme.Sections.register("featured-collections", theme.FeaturedCollectionsSection),
        theme.Sections.register("background-video", theme.VideoManager),
        theme.Sections.register("gallery", theme.GallerySection),
        theme.Sections.register("announcement-bar", theme.AnnouncementBarSection, {
            deferredLoad: !1
        }),
        theme.Sections.register("product-recommendations", theme.ProductRecommendations),
        theme.Sections.register("testimonials", theme.TestimonialsSection),
        theme.Sections.register("search-template", theme.FilterManager, {
            deferredLoad: !1
        })
    }),
    $(function($) {
        b.sections.length ? b.sections.forEach(a=>{
            try {
                var b = {};
                void 0 !== a.deferredLoad && (b.deferredLoad = a.deferredLoad),
                void 0 !== a.deferredLoadViewportExcess && (b.deferredLoadViewportExcess = a.deferredLoadViewportExcess),
                theme.Sections.register(a.name, a.section, b)
            } catch (c) {
                console.error("Unable to register section ".concat(a.name, "."), c)
            }
        }
        ) : console.warn("Barry: No common sections have been registered.")
    })
}(jQuery)

var t = false;
if(document.querySelector('.container.product-container')){
    t = document.querySelector('.container.product-container').getAttribute('data-metafield');
}

if (t == 'true'){
console.log('---> true');

    setTimeout(function(){
        var active_swatch ='';
      document.querySelectorAll('.selector-wrapper--swatch ul li').forEach(function(e){
        e.addEventListener('click',function(){
            var img_show = this.children[0].title;
            console.log('img_show',img_show);
            var slick_elem = this.closest('.product-container').querySelectorAll('.thumbnails');
            $('.product-slideshow').slick('unslick')
            this.closest('.product-container').querySelectorAll('.product-slideshow .product-media').forEach(function(main_img_element){
                
// console.log(main_img_element.querySelector('.rimage__image').alt.split('|'));

let alt_text = main_img_element.dataset.altMedia;

                let parts = alt_text.split('|');
                let partss = parts[parts.length - 1].trim();
                    
                img_show = String(img_show);

                if (partss.toUpperCase() == img_show.toUpperCase() || partss.toUpperCase() == 'ALWAYS'){      
                    console.log(partss,'====',img_show);        
                    main_img_element.classList.remove('hide-thumbanail-image');
                    main_img_element.classList.add('slide-to-show_main'); 
                }else{
                    console.warn(partss,'====',img_show);
                    main_img_element.classList.add('hide-thumbanail-image');
                    main_img_element.classList.remove('slide-to-show_main');
                }
            })
         
            setTimeout(function(){
                console.log('SLICK Run');
            $(".product-slideshow").slick({
                slide: '.slide-to-show_main',
                fade: !1,
                speed: 500,
                arrows: !0,
                dots: !1,
                infinite: !1,
                useTransform: !0,
                adaptiveHeight: !0,
                prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                cssEase: "cubic-bezier(0.25, 1, 0.5, 1)"
            });
        },20);
  

            $('.thumbnails').slick('unslick')
            this.closest('.product-container').querySelectorAll('.thumbnails .thumbnail--media-image,.thumbnails .thumbnail--media-external_video,.thumbnails .thumbnail--media-video').forEach(function(img_element){

                let alt_text = img_element.querySelector('.rimage__image').alt;
                let parts = alt_text.split('|');
                let partss = parts[parts.length - 1].trim();
                img_show = String(img_show);

                if (partss.toUpperCase() == img_show.toUpperCase() || partss.toUpperCase() == 'ALWAYS'){                   
                    console.log(img_show,img_element.querySelector('.rimage__image'))
                    img_element.classList.remove('hide-thumbanail-image');
                    img_element.classList.add('silde-to-show');
                }else{
                    img_element.classList.add('hide-thumbanail-image');
                    img_element.classList.remove('silde-to-show');
                }
            })
            $('.thumbnails').slick({
                slide: '.silde-to-show',
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: !1,
                speed: 400,
                prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                responsive: [{
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }, {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        arrows: !1,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
            }]});
            
            console.log('Sliderrrrr 2');
            $('.product-container .thumbnails').slick('slickGoTo',  1);
            
        });
        
        if(e.children[0].classList.contains('active')){
            active_swatch =e.children[0].title
           
        }
        
      })
      if(active_swatch != ''){
        console.log('Not blank',active_swatch);
      $('.product-slideshow').slick('unslick')
      document.querySelector('.product-container').querySelectorAll('.product-slideshow .product-media').forEach(function(load_main_img_element){

        let alt_text = load_main_img_element.dataset.altMedia;

        let parts = alt_text.split('|');
        let partss = parts[parts.length - 1].trim();
            
        active_swatch = String(active_swatch);

        if (partss.toUpperCase() == active_swatch.toUpperCase() || partss.toUpperCase() == 'ALWAYS'){                
                    load_main_img_element.classList.remove('hide-thumbanail-image');
                    load_main_img_element.classList.add('main_silde-to-show');
                }else{
                    load_main_img_element.classList.add('hide-thumbanail-image');
                    load_main_img_element.classList.remove('main_silde-to-show');
                }
            })
            $(".product-slideshow").slick({
                slide: '.main_silde-to-show',
                fade: !1,
                speed: 500,
                arrows: !0,
                dots: !1,
                infinite: !1,
                useTransform: !0,
                adaptiveHeight: !0,
                prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
                nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
                cssEase: "cubic-bezier(0.25, 1, 0.5, 1)"
            })

       
      var all_thumbnails = document.querySelector('.product-container').querySelector('.thumbnails');
      $('.product-container .thumbnails').slick('unslick')
      document.querySelector('.product-container').querySelectorAll('.thumbnails .thumbnail--media-image,.thumbnails .thumbnail--media-external_video,.thumbnails .thumbnail--media-video').forEach(function(current_thumbnail){
        
        let alt_text = current_thumbnail.querySelector('.rimage__image').alt;
        let parts = alt_text.split('|');
        let partss = parts[parts.length - 1].trim();
            
        active_swatch = String(active_swatch);

        if (partss.toUpperCase() == active_swatch.toUpperCase() || partss.toUpperCase() == 'ALWAYS'){  

        
            current_thumbnail.classList.remove('hide-thumbanail-image');
            current_thumbnail.classList.add('thumb_silde-to-show');
        }else{
            current_thumbnail.classList.add('hide-thumbanail-image');
            current_thumbnail.classList.remove('thumb_silde-to-show');
        }
      })
      $('.product-container .thumbnails').slick({
        slide: '.thumb_silde-to-show',
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: !1,
        speed: 400,
        prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + "</button>",
        nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + "</button>",
        responsive: [{
            breakpoint: 1500,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 767,
            settings: {
                arrows: !1,
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }]});
        console.log('Sliderrrrr 2');
        $('.product-container .thumbnails').slick('slickGoTo',  1);
    }
    document.querySelector('.product-container').querySelector('.thumbnails').style.opacity = 1;
    },1000);


}else{
    // console.log('---> False inside');
}